import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { __awaiter } from 'tslib';
import { formatDate } from '@angular/common';
import * as AWS from 'aws-sdk';
import * as i3 from 'dynamolib';
import * as cloneDeep from 'lodash/cloneDeep';

/**
 * This class will have the constants used in the application
 */
class Constants {
    static getLogLevelStr(loglevel) {
        switch (loglevel) {
            case Constants.LOG_DEBUG: return 'DEBUG';
            case Constants.LOG_INFO: return 'INFO';
            case Constants.LOG_AUDIT: return 'AUDIT';
            case Constants.LOG_WARNING: return 'WARNING';
            case Constants.LOG_ERROR: return 'ERROR';
            default: return 'LOG';
        }
    }
}
/**
 * Environment - 'dev', 'test' or 'prod'
 */
Constants.ENV = "dev";
/**
 * App Version
 */
Constants.VERSION = "1.0.0";
/**
 * Application Name - This will be prefix of table names
 */
Constants.APP_NAME = "q5care";
/**
 * Log level set, above this level it will log
 */
Constants.LOG_LEVEL = 1;
/**
 * LOG LEVEL DEBUG
 */
Constants.LOG_DEBUG = 0;
/**
 * LOG LEVEL INFO
 */
Constants.LOG_INFO = 1;
/**
 * LOG LEVEL AUDIT
 */
Constants.LOG_AUDIT = 2;
/**
 * LOG LEVEL WARNING
 */
Constants.LOG_WARNING = 3;
/**
 * LOG LEVEL ERROR/EXCEPTION
 */
Constants.LOG_ERROR = 4;
/**
 * Admin privileges
 */
Constants.PRIV_SETUP_LOCATIONS = "101";
Constants.PRIV_SETUP_CATALOGUE = "102";
Constants.PRIV_SETUP_ENTITY = "103";
Constants.PRIV_SETUP_USERS = "104";
Constants.PRIV_MANAGE_LEADS = "105";
/**
 * Error Codes
 */
Constants.INIT_MASTER_ERROR = 501;
Constants.DML_DUPLICATE = 701;
Constants.DML_MANDATORY_MISSING = 702;
Constants.DB_WRITE_FAILED = 703;
Constants.DML_PARENT_CHECK_FAILED = 704;
Constants.S3_ACCESS_ID = "AKIA5VQR7V7YSJZYWOOZ";
Constants.S3_KEY = "FJnM/yfjPKi/R32LmV5tEntGGBkm9+eOM5ibUo8D";
Constants.doctypes = [{ doctypecode: 'pan', doctypename: 'PAN Card' },
    { doctypecode: 'gst', doctypename: 'GST Certificate' },
    { doctypecode: 'agreement', doctypename: 'Vendor Agreement' },
    { doctypecode: 'sec', doctypename: 'Shop Est. Cert.' },
    { doctypecode: 'aadhar', doctypename: 'Aadhar Card' }];

class UtilService {
    constructor(dbService) {
        this.dbService = dbService;
    }
    log(loglevel, logmessage) {
        var curtime = formatDate(new Date(), "HH:mm:ss.SSS", "en-US");
        if (loglevel > Constants.LOG_LEVEL) {
            var llstr = Constants.getLogLevelStr(loglevel);
            if (loglevel == Constants.LOG_ERROR || loglevel == Constants.LOG_WARNING) {
                console.error(curtime + ":" + llstr + ": " + logmessage);
            }
            else {
                console.log(curtime + ":" + llstr + ": " + logmessage);
            }
        }
    }
    round(input, decimals) {
        switch (decimals) {
            case 2: return Math.round(input * 100) / 100;
            case 3: return Math.round(input * 1000) / 1000;
            case 4: return Math.round(input * 10000) / 10000;
            default: return Math.round(input * 100) / 100;
        }
    }
    getTableName(tablename) {
        return Constants.APP_NAME + "_" + Constants.ENV + "_" + tablename;
    }
    getCurrentBusinessDate() {
        var curdate = formatDate(this.dbService.getTime(), "YYYYMMdd", "en-US");
        return parseInt(curdate);
    }
    sendOTPOnWhatsApp(receivermobile, receivername, otptosend) {
        return __awaiter(this, void 0, void 0, function* () {
            var url = "https://lj7724mli5.execute-api.ap-south-1.amazonaws.com/prod/sendwhatsappmsg";
            var templateparams = [{ "type": "text", "text": receivername },
                { "type": "text", "text": otptosend }];
            var body = { "portno": "11140", "namespace": "b9a23cb4_89ed_4fe2_b849_20775908ff5e", "countrycode": "91", "mobileno": receivermobile, "templatename": "otp_verification", "templateparams": templateparams };
            var headers = { 'content-type': 'application/json' };
            console.log('**OTP API **' + url + ' PARAMS ' + JSON.stringify(body));
            var resp = yield this.dbService.httpdataService.httpRequest(url, 'POST', body, headers);
        });
    }
    /*async sendOTPOnWhatsApp(receivermobile, receivername, otptosend){
      var url = "https://lj7724mli5.execute-api.ap-south-1.amazonaws.com/prod/sendwhatsappmsg";
    
      var templateparams = [{ "type": "text","text": receivername},
                               {"type": "text","text": otptosend}]
    
    
     var body =  {"portno": "8661","namespace" : "4a9b95df_9523_4442_9c1d_c3c43cf7b807", "countrycode" : "91", "mobileno": receivermobile, "templatename" : "opt_verification", "templateparams" : templateparams};
     var headers = {'content-type': 'application/json'};
     console.log('**OTP API **' + url + ' PARAMS ' + JSON.stringify(body));
     var resp = await this.dbService.httpdataService.httpRequest(url,'POST',body, headers);
  }*/
    sendCallbackNotification(receivermobile, customernumber) {
        return __awaiter(this, void 0, void 0, function* () {
            var url = "https://lj7724mli5.execute-api.ap-south-1.amazonaws.com/prod/sendwhatsappmsg";
            var templateparams = [{ "type": "text", "text": customernumber }];
            var body = { "portno": "11140", "namespace": "b9a23cb4_89ed_4fe2_b849_20775908ff5e", "countrycode": "91", "mobileno": receivermobile, "templatename": "unregistered_customer_details", "templateparams": templateparams };
            var headers = { 'content-type': 'application/json' };
            var resp = yield this.dbService.httpdataService.httpRequest(url, 'POST', body, headers);
        });
    }
    sendOrderNotification(order, urlord, contactno, terms) {
        return __awaiter(this, void 0, void 0, function* () {
            var url = "https://lj7724mli5.execute-api.ap-south-1.amazonaws.com/prod/sendwhatsappmsg";
            var deladdr = order.shippingaddress;
            var straddress = deladdr.contactpersonname + " - " + deladdr.contactpersonno + ", " + deladdr.addressline1 + ", " + deladdr.maintext + ", " + deladdr.pincode;
            var templateparams = [{ "type": "text", "text": order.customer.name },
                { "type": "text", "text": order.id },
                { "type": "text", "text": "" + order.cart.netpayable },
                { "type": "text", "text": order.paymentlist[0].paymentmode.toUpperCase() },
                { "type": "text", "text": straddress },
                { "type": "text", "text": urlord },
                { "type": "text", "text": contactno },
                { "type": "text", "text": terms }];
            var body = { "portno": "11140", "namespace": "b9a23cb4_89ed_4fe2_b849_20775908ff5e", "countrycode": "91", "mobileno": order.customer.mobileno, "templatename": "web_order_confirmation", "templateparams": templateparams };
            var headers = { 'content-type': 'application/json' };
            console.log('**OTP API **' + url + ' PARAMS ' + JSON.stringify(body));
            var resp = yield this.dbService.httpdataService.httpRequest(url, 'POST', body, headers);
        });
    }
    getAuditTransactionItem(tablename, item) {
        var txnitem = {};
        txnitem.dmltype = 'create';
        txnitem.tablename = tablename;
        txnitem.item = item;
        var curtimestr = formatDate(this.dbService.getTime(), "YYYY-MM-dd HH:mm", "en-US");
        item.updatedat = curtimestr;
        item.updatedby = this.loggedinusername;
        return txnitem;
    }
    getTransactionItem(dmltype, tablename, item, conditionexpression, expressionattributvalues) {
        var txnitem = {};
        txnitem.dmltype = dmltype;
        txnitem.tablename = tablename;
        txnitem.item = item;
        var curtimestr = formatDate(this.dbService.getTime(), "YYYY-MM-dd HH:mm", "en-US");
        item.updatedat = curtimestr;
        item.updatedby = this.loggedinusername;
        if (dmltype == 'create') {
            item.createdat = curtimestr;
            if (!item.createdby || item.createdby.length == 0)
                item.createdby = this.loggedinusername;
            item.objectversion = 1;
        }
        else if (dmltype == 'edit') {
            var curversion = item.objectversion;
            conditionexpression = "objectversion = :version";
            expressionattributvalues = { ":version": curversion };
            item.objectversion = item.objectversion + 1;
        }
        else {
            item.isarchived = true;
        }
        txnitem.conditionexpression = conditionexpression;
        txnitem.expressionattributvalues = expressionattributvalues;
        return txnitem;
    }
    uploadFiletoS3(file, strfilename) {
        return __awaiter(this, void 0, void 0, function* () {
            AWS.config.accessKeyId = Constants.S3_ACCESS_ID;
            AWS.config.secretAccessKey = Constants.S3_KEY;
            AWS.config.region = 'ap-south-1';
            var params, contentType;
            if (strfilename.toUpperCase().indexOf("PDF") >= 0) {
                contentType = 'application/pdf';
                params = { Bucket: 'q5carefiles', Key: strfilename, ContentType: contentType, Body: file };
            }
            else {
                params = { Bucket: 'q5carefiles', Key: strfilename, Body: file };
            }
            /*if(file.size > 10000000){
                return {status : 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'File size must be lesser than 10 MB!'};
            }*/
            var s3bucket = new AWS.S3({ params: { Bucket: 'q5carefiles' } });
            var retpromise = yield s3bucket.upload(params).promise();
            if (retpromise && retpromise.Location && retpromise.Location.length > 0) {
                return { status: 'success' };
            }
            else {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Error in file upload!' };
            }
        });
    }
    sendBackofficeNotification(order, number1, number2, number3) {
        return __awaiter(this, void 0, void 0, function* () {
            var url = "https://lj7724mli5.execute-api.ap-south-1.amazonaws.com/prod/sendwhatsappmsg";
            var deladdr = order.shippingaddress;
            var straddress = deladdr.contactpersonname + " - " + deladdr.contactpersonno + ", " + deladdr.addressline1 + ", " + deladdr.maintext;
            if (deladdr.pincode)
                straddress = straddress + ", " + deladdr.pincode;
            var delmode = order.cart.handovermode.toUpperCase();
            if (delmode == 'PICKUP')
                delmode = 'PICKUP FROM STORE';
            var productdetails = "";
            var i = 0;
            for (var item of order.cart.lineitems) {
                i++;
                var rentperiod = "";
                var rentperiodunit = "";
                var depositamount = "";
                productdetails = productdetails + "Item (" + i + "): " + item.billingtype + ", " + item.productname + "-" + item.brandname + "-"
                    + item.modelno + ", Qty: " + item.quantity;
                if (item.billingtype == 'RENT') {
                    rentperiod = "" + item.rentperiod;
                    rentperiodunit = item.rentperiodunit;
                    depositamount = "" + item.depositamount;
                    productdetails = productdetails + ", Rent Period: " + rentperiod + " " + rentperiodunit + ", Deposit amount: " + depositamount;
                }
                productdetails = productdetails + ", Rate: " + item.rate + ", Discount: " + item.itemdiscountvalue + ", Item amount: " + item.totalpayableamount + " ...... ";
            }
            var templateparams = [
                { "type": "text", "text": delmode },
                { "type": "text", "text": order.createdat },
                { "type": "text", "text": order.id },
                { "type": "text", "text": order.customer.name },
                { "type": "text", "text": order.customer.mobileno },
                { "type": "text", "text": straddress },
                { "type": "text", "text": productdetails },
                { "type": "text", "text": "" + order.cart.sumitemcount },
                { "type": "text", "text": "" + order.cart.netpayable },
                { "type": "text", "text": order.paymentlist[0].paymentmode.toUpperCase() }
            ];
            var body = { "portno": "11140", "namespace": "b9a23cb4_89ed_4fe2_b849_20775908ff5e", "countrycode": "91", "mobileno": number1, "templatename": "usersite_orders", "templateparams": templateparams };
            var headers = { 'content-type': 'application/json' };
            var resp = yield this.dbService.httpdataService.httpRequest(url, 'POST', body, headers);
            if (number2) {
                body = { "portno": "11140", "namespace": "b9a23cb4_89ed_4fe2_b849_20775908ff5e", "countrycode": "91", "mobileno": number2, "templatename": "usersite_orders", "templateparams": templateparams };
                resp = yield this.dbService.httpdataService.httpRequest(url, 'POST', body, headers);
            }
            if (number3) {
                body = { "portno": "11140", "namespace": "b9a23cb4_89ed_4fe2_b849_20775908ff5e", "countrycode": "91", "mobileno": number3, "templatename": "usersite_orders", "templateparams": templateparams };
                resp = yield this.dbService.httpdataService.httpRequest(url, 'POST', body, headers);
            }
        });
    }
}
UtilService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: UtilService, deps: [{ token: i3.DynamoLibService }], target: i0.ɵɵFactoryTarget.Injectable });
UtilService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: UtilService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: UtilService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i3.DynamoLibService }]; } });

class PrivilegeService {
    constructor() { }
    getPrivilegeOptions() {
        var options = [];
        options.push({ label: 'Location Setup', value: Constants.PRIV_SETUP_LOCATIONS });
        options.push({ label: 'Catalogue Setup', value: Constants.PRIV_SETUP_CATALOGUE });
        options.push({ label: 'Entity Setup', value: Constants.PRIV_SETUP_ENTITY });
        options.push({ label: 'Users and Privileges', value: Constants.PRIV_SETUP_USERS });
        options.push({ label: 'Lead management', value: Constants.PRIV_MANAGE_LEADS });
        return options;
    }
    validatePrivilege(user, action) {
        if (user.privileges) {
            for (var priv of user.privileges) {
                if (priv == action)
                    return true;
            }
        }
        return false;
    }
    getPrivNameForId(privid) {
        switch (privid) {
            case Constants.PRIV_SETUP_LOCATIONS: return "Location Setup";
            case Constants.PRIV_SETUP_ENTITY: return "Entity Setup";
            case Constants.PRIV_SETUP_CATALOGUE: return "Catalogue Setup";
            case Constants.PRIV_SETUP_USERS: return "Users and Privileges";
            case Constants.PRIV_MANAGE_LEADS: return "Lead Management";
        }
        return "";
    }
    getPrivilegeString(usergroup) {
        var retstring = "";
        for (var priv of usergroup.privileges) {
            retstring = retstring + this.getPrivNameForId(priv) + ", ";
        }
        if (retstring.length > 5)
            retstring = retstring.substring(0, retstring.length - 2);
        return retstring;
    }
}
PrivilegeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: PrivilegeService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
PrivilegeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: PrivilegeService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: PrivilegeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class AppdataService {
    constructor(dblib, privService, util) {
        this.dblib = dblib;
        this.privService = privService;
        this.util = util;
    }
    bootstrapParams(credentials, username, loglevel, env, appname) {
        return __awaiter(this, void 0, void 0, function* () {
            Constants.LOG_LEVEL = loglevel;
            Constants.APP_NAME = appname;
            Constants.ENV = env;
            this.util.loggedinusername = username;
            //this.util.loggedinusername = username;
            return yield this.dblib.initializeKeyAccess(credentials, false);
        });
    }
    initUsergroups() {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "initUsergroups++");
            var tablename = this.util.getTableName('usergroup');
            var usergrouplist = yield this.dblib.scanTable(tablename);
            if (!usergrouplist) {
                this.util.log(Constants.LOG_ERROR, "Error in usergroups initialization");
                this.initerror = true;
                return;
            }
            this.usergrouplist = [];
            for (var usergroup of usergrouplist) {
                if (!usergroup.isarchived) {
                    usergroup.privilegestring = this.privService.getPrivilegeString(usergroup);
                    this.usergrouplist.push(usergroup);
                }
            }
            this.mastersinitdone.push('usergroup');
            this.util.log(Constants.LOG_DEBUG, "initUsergroups--");
        });
    }
    initUsers() {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "initUsers++");
            var tablename = this.util.getTableName('user');
            var userlist = yield this.dblib.scanTable(tablename);
            if (!userlist) {
                this.util.log(Constants.LOG_ERROR, "Error in users initialization");
                this.initerror = true;
                return;
            }
            this.userlist = [];
            for (var user of userlist) {
                if (!user.isarchived)
                    this.userlist.push(user);
            }
            this.mastersinitdone.push('user');
            this.util.log(Constants.LOG_DEBUG, "initUsers--");
        });
    }
    initStates() {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "initStates++");
            var tablename = this.util.getTableName('state');
            var statelist = yield this.dblib.scanTable(tablename);
            if (!statelist) {
                this.util.log(Constants.LOG_ERROR, "Error in states initialization");
                this.initerror = true;
                return;
            }
            this.statelist = [];
            for (var state of statelist) {
                if (!state.isarchived)
                    this.statelist.push(state);
            }
            this.mastersinitdone.push('state');
            this.util.log(Constants.LOG_DEBUG, "initStates--");
        });
    }
    initCities() {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "initCities++");
            var tablename = this.util.getTableName('city');
            var citylist = yield this.dblib.scanTable(tablename);
            if (!citylist) {
                this.util.log(Constants.LOG_ERROR, "Error in city initialization");
                this.initerror = true;
                return;
            }
            this.citylist = [];
            for (var city of citylist) {
                if (!city.isarchived)
                    this.citylist.push(city);
            }
            this.mastersinitdone.push('city');
            this.util.log(Constants.LOG_DEBUG, "initCities--");
        });
    }
    initWarehouses() {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "initWarehouses++");
            var tablename = this.util.getTableName('warehouse');
            var warehouselist = yield this.dblib.scanTable(tablename);
            if (!warehouselist) {
                this.util.log(Constants.LOG_ERROR, "Error in warehouses initialization");
                this.initerror = true;
                return;
            }
            this.warehouselist = [];
            for (var warehouse of warehouselist) {
                if (!warehouse.isarchived)
                    this.warehouselist.push(warehouse);
            }
            this.mastersinitdone.push('warehouse');
            this.util.log(Constants.LOG_DEBUG, "initWarehouses--");
        });
    }
    initVendors() {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "initVendors++");
            var tablename = this.util.getTableName('vendor');
            var vendorlist = yield this.dblib.scanTable(tablename);
            if (!vendorlist) {
                this.util.log(Constants.LOG_ERROR, "Error in vendors initialization");
                this.initerror = true;
                return;
            }
            this.vendorlist = [];
            for (var vendor of vendorlist) {
                if (!vendor.isarchived)
                    this.vendorlist.push(vendor);
            }
            this.mastersinitdone.push('vendor');
            this.util.log(Constants.LOG_DEBUG, "initVendors--");
        });
    }
    initBrands() {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "initBrands++");
            var tablename = this.util.getTableName('brand');
            var brandlist = yield this.dblib.scanTable(tablename);
            if (!brandlist) {
                this.util.log(Constants.LOG_ERROR, "Error in brands initialization");
                this.initerror = true;
                return;
            }
            this.brandlist = [];
            for (var brand of brandlist) {
                if (!brand.isarchived)
                    this.brandlist.push(brand);
            }
            this.mastersinitdone.push('brand');
            this.util.log(Constants.LOG_DEBUG, "initBrands--");
        });
    }
    initProductspecifications() {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "initProductspecifications++");
            var tablename = this.util.getTableName('productspecification');
            var productspecificationlist = yield this.dblib.scanTable(tablename);
            if (!productspecificationlist) {
                this.util.log(Constants.LOG_ERROR, "Error in productspecifications initialization");
                this.initerror = true;
                return;
            }
            this.productspecificationlist = [];
            for (var productspecification of productspecificationlist) {
                if (!productspecification.isarchived)
                    this.productspecificationlist.push(productspecification);
            }
            this.mastersinitdone.push('productspecification');
            this.util.log(Constants.LOG_DEBUG, "initProductspecifications--");
        });
    }
    initProductcitypricings() {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "initProductcitypricings++");
            var tablename = this.util.getTableName('productcitypricing');
            var productcitypricinglist = yield this.dblib.scanTable(tablename);
            if (!productcitypricinglist) {
                this.util.log(Constants.LOG_ERROR, "Error in productcitypricings initialization");
                this.initerror = true;
                return;
            }
            this.productcitypricinglist = [];
            for (var productcitypricing of productcitypricinglist) {
                if (!productcitypricing.isarchived)
                    this.productcitypricinglist.push(productcitypricing);
            }
            this.mastersinitdone.push('productcitypricing');
            this.util.log(Constants.LOG_DEBUG, "initProductcitypricings--");
        });
    }
    initB2BCustomerPricing() {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "initB2BCustomerPricing++");
            var tablename = this.util.getTableName('b2bcustomerpricing');
            var b2bcustomerpricinglist = yield this.dblib.scanTable(tablename);
            if (!b2bcustomerpricinglist) {
                this.util.log(Constants.LOG_ERROR, "Error in b2bcustomerpricing initialization");
                this.initerror = true;
                return;
            }
            this.b2bcustomerpricinglist = [];
            for (var b2bcustomerpricing of b2bcustomerpricinglist) {
                if (!b2bcustomerpricing.isarchived)
                    this.b2bcustomerpricinglist.push(b2bcustomerpricing);
            }
            this.mastersinitdone.push('b2bcustomerpricing');
            this.util.log(Constants.LOG_DEBUG, "initb2bcustomerpricing--");
        });
    }
    initAgents() {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "initAgents++");
            var tablename = this.util.getTableName('agent');
            var agentlist = yield this.dblib.scanTable(tablename);
            if (!agentlist) {
                this.util.log(Constants.LOG_ERROR, "Error in agents initialization");
                this.initerror = true;
                return;
            }
            this.agentlist = [];
            for (var agent of agentlist) {
                if (!agent.isarchived)
                    this.agentlist.push(agent);
            }
            this.mastersinitdone.push('agent');
            this.util.log(Constants.LOG_DEBUG, "initAgents--");
        });
    }
    initBusinesscustomers() {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "initBusinesscustomers++");
            var tablename = this.util.getTableName('businesscustomer');
            var businesscustomerlist = yield this.dblib.scanTable(tablename);
            if (!businesscustomerlist) {
                this.util.log(Constants.LOG_ERROR, "Error in businesscustomers initialization");
                this.initerror = true;
                return;
            }
            this.businesscustomerlist = [];
            for (var businesscustomer of businesscustomerlist) {
                if (!businesscustomer.isarchived)
                    this.businesscustomerlist.push(businesscustomer);
            }
            this.mastersinitdone.push('businesscustomer');
            this.util.log(Constants.LOG_DEBUG, "initBusinesscustomers--");
        });
    }
    applyDiscount(product) {
        product.productpricing.retaildiscountedrate = product.productpricing.retailsellingrate;
        product.productpricing.retaildiscountedrent = product.productpricing.retailmonthlyrent;
        if (product.productpricing.retaildiscountbuy > 0) {
            product.productpricing.retaildiscountedrate = this.util.round(product.productpricing.retailsellingrate * (100 - product.productpricing.retaildiscountbuy) / 100, 2);
        }
        if (product.productpricing.retaildiscountrent > 0) {
            product.productpricing.retaildiscountedrent = this.util.round(product.productpricing.retailmonthlyrent * (100 - product.productpricing.retaildiscountrent) / 100, 2);
        }
    }
    initProducts() {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "initProducts++");
            var tablename = this.util.getTableName('product');
            var productlist = yield this.dblib.scanTable(tablename);
            if (!productlist) {
                this.util.log(Constants.LOG_ERROR, "Error in products initialization");
                this.initerror = true;
                return;
            }
            this.productlist = [];
            for (var product of productlist) {
                if (!product.isarchived) {
                    this.applyDiscount(product);
                    this.productlist.push(product);
                }
            }
            this.mastersinitdone.push('product');
            this.util.log(Constants.LOG_DEBUG, "initProducts--");
            this.productlist.sort((a, b) => (a.sortorder) < (b.sortorder) ? -1 : 1);
        });
    }
    initProductcategories() {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "initProductcategories++");
            var tablename = this.util.getTableName('productcategory');
            var productcategorylist = yield this.dblib.scanTable(tablename);
            if (!productcategorylist) {
                this.util.log(Constants.LOG_ERROR, "Error in productcategory  initialization");
                this.initerror = true;
                return;
            }
            this.categorylist = [];
            for (var productcategory of productcategorylist) {
                if (!productcategory.isarchived)
                    this.categorylist.push(productcategory);
            }
            this.categorylist.sort((a, b) => (a.sortorder) < (b.sortorder) ? -1 : 1);
            this.mastersinitdone.push('productcategory');
            this.util.log(Constants.LOG_DEBUG, "initProductcategories--");
        });
    }
    initProductsubcategories() {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "initProductsubcategories++");
            var tablename = this.util.getTableName('productsubcategory');
            var productsubcategorylist = yield this.dblib.scanTable(tablename);
            if (!productsubcategorylist) {
                this.util.log(Constants.LOG_ERROR, "Error in productsubcategory initialization");
                this.initerror = true;
                return;
            }
            this.subcategorylist = [];
            for (var productsubcategory of productsubcategorylist) {
                if (!productsubcategory.isarchived)
                    this.subcategorylist.push(productsubcategory);
            }
            this.subcategorylist.sort((a, b) => (a.sortorder) < (b.sortorder) ? -1 : 1);
            this.mastersinitdone.push('productsubcategory');
            this.util.log(Constants.LOG_DEBUG, "initProductsubcategories--");
        });
    }
    initVendorpricings() {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "initVendorpricings++");
            var tablename = this.util.getTableName('vendorpricing');
            var conditionexpression = "vendorid = :v_vendorid ";
            var attribparams = { ":v_vendorid": this.loggedinvendor.id };
            var vendorpricingslist = yield this.dblib.queryDB(tablename, null, conditionexpression, null, null, attribparams, null, null, null, true, true);
            if (!vendorpricingslist) {
                this.util.log(Constants.LOG_ERROR, "Error in Vendorpricings initialization");
                this.initerror = true;
                return;
            }
            this.vendorpricinglist = [];
            for (var vendorpricing of vendorpricingslist) {
                if (!vendorpricing.isarchived)
                    this.vendorpricinglist.push(vendorpricing);
            }
            this.mastersinitdone.push('vendorpricing');
            this.util.log(Constants.LOG_DEBUG, "initVendorpricings--");
        });
    }
    initMasterData() {
        this.initerror = false;
        this.mastersinitdone = [];
        //Call the master init concurrently, the watcher (initstatus) function will be invoked by caller
        this.initStates();
        this.initCities();
        this.initBrands();
        this.initVendors();
        this.initProductcategories();
        this.initProducts();
        this.initAgents();
        this.initProductsubcategories();
        this.initBusinesscustomers();
        this.initWarehouses();
        this.initProductspecifications();
        this.initB2BCustomerPricing();
        this.initProductcitypricings();
        this.initUsergroups();
        this.initUsers();
    }
    initMasterDataCustomer() {
        this.initerror = false;
        this.mastersinitdone = [];
        this.initStates();
        this.initCities();
        this.initBrands();
        this.initProductcategories();
        this.initProducts();
        this.initProductsubcategories();
        this.initProductcitypricings();
    }
    setCityPricingForProduct(product, cityid) {
        //console.log ('PRODUCT  ' + product.name + ' BILLING TYPE ' + product.billingtype + ' ORIGINAL RATE ' + product.productpricing.retailmonthlyrent  + ' NEW DEPOSIT ' + pricing.citypricing.depositforrent);
        var pricing = this.getCityPricingForProduct(product, cityid);
        if (pricing) {
            if (pricing.pricingtype == 'different') {
                if (pricing.citypricing.retailmonthlyrent && pricing.citypricing.retailmonthlyrent > 0)
                    product.productpricing.retailmonthlyrent = pricing.citypricing.retailmonthlyrent;
                if (pricing.citypricing.retailsellingrate && pricing.citypricing.retailsellingrate > 0)
                    product.productpricing.retailsellingrate = pricing.citypricing.retailsellingrate;
                if (pricing.citypricing.depositforrent && pricing.citypricing.depositforrent > 0)
                    product.productpricing.depositforrent = pricing.citypricing.depositforrent;
                this.applyDiscount(product);
            }
            else {
                if (product.billingtype == 'RENT' || product.billingtype == 'BOTH') {
                    if (pricing.relativeinpercentrent) {
                        product.productpricing.retailweeklyrent = product.productpricing.retailweeklyrent + Math.round(product.productpricing.retailweeklyrent * pricing.escalationvaluerent / 100);
                        product.productpricing.retailmonthlyrent = product.productpricing.retailmonthlyrent + Math.round(product.productpricing.retailmonthlyrent * pricing.escalationvaluerent / 100);
                    }
                    else {
                        product.productpricing.retailweeklyrent = product.productpricing.retailweeklyrent + pricing.escalationvaluerent;
                        product.productpricing.retailmonthlyrent = product.productpricing.retailmonthlyrent + pricing.escalationvaluerent;
                    }
                }
                if (product.billingtype == 'SALE' || product.billingtype == 'BOTH') {
                    if (pricing.relativeinpercentsale) {
                        product.productpricing.retailsellingrate = product.productpricing.retailsellingrate + Math.round(product.productpricing.retailsellingrate * pricing.escalationvaluesale / 100);
                    }
                    else {
                        product.productpricing.retailsellingrate = product.productpricing.retailsellingrate + pricing.escalationvaluesale;
                    }
                }
                this.applyDiscount(product);
            }
        }
    }
    getCityPricingForProduct(product, cityid) {
        for (var pricing of this.productcitypricinglist) {
            if (pricing.cityid == cityid && pricing.productid == product.id)
                return pricing;
        }
        return null;
    }
    setCityPricing(cityid) {
        for (var pricing of this.productcitypricinglist) {
            if (pricing.cityid == cityid) {
                var product = this.getProductForId(pricing.productid);
                console.log('PRODUCT  ' + product.name + ' BILLING TYPE ' + product.billingtype + ' ORIGINAL RATE ' + product.productpricing.retailmonthlyrent + ' NEW DEPOSIT ' + pricing.citypricing.depositforrent);
                if (product.pricingsetforcity != cityid) {
                    //Set city pricing
                    product.pricingsetforcity = cityid;
                    if (pricing.pricingtype == 'different') {
                        //if(pricing.citypricing.retailweeklyrent && pricing.citypricing.retailweeklyrent > 0 ) product.productpricing.retailweeklyrent = pricing.citypricing.retailweeklyrent;
                        if (pricing.citypricing.retailmonthlyrent && pricing.citypricing.retailmonthlyrent > 0)
                            product.productpricing.retailmonthlyrent = pricing.citypricing.retailmonthlyrent;
                        if (pricing.citypricing.retailsellingrate && pricing.citypricing.retailsellingrate > 0)
                            product.productpricing.retailsellingrate = pricing.citypricing.retailsellingrate;
                        if (pricing.citypricing.depositforrent && pricing.citypricing.depositforrent > 0)
                            product.productpricing.depositforrent = pricing.citypricing.depositforrent;
                        this.applyDiscount(product);
                    }
                    else {
                        if (product.billingtype == 'RENT' || product.billingtype == 'BOTH') {
                            if (pricing.relativeinpercentrent) {
                                product.productpricing.retailweeklyrent = product.productpricing.retailweeklyrent + Math.round(product.productpricing.retailweeklyrent * pricing.escalationvaluerent / 100);
                                product.productpricing.retailmonthlyrent = product.productpricing.retailmonthlyrent + Math.round(product.productpricing.retailmonthlyrent * pricing.escalationvaluerent / 100);
                            }
                            else {
                                product.productpricing.retailweeklyrent = product.productpricing.retailweeklyrent + pricing.escalationvaluerent;
                                product.productpricing.retailmonthlyrent = product.productpricing.retailmonthlyrent + pricing.escalationvaluerent;
                            }
                        }
                        if (product.billingtype == 'SALE' || product.billingtype == 'BOTH') {
                            if (pricing.relativeinpercentsale) {
                                product.productpricing.retailsellingrate = product.productpricing.retailsellingrate + Math.round(product.productpricing.retailsellingrate * pricing.escalationvaluesale / 100);
                            }
                            else {
                                product.productpricing.retailsellingrate = product.productpricing.retailsellingrate + pricing.escalationvaluesale;
                            }
                        }
                        this.applyDiscount(product);
                    }
                }
            }
        }
        this.productlist = [...this.productlist];
    }
    initMasterDataVendor() {
        this.initerror = false;
        this.mastersinitdone = [];
        //Call the master init concurrently, the watcher (initstatus) function will be invoked by caller
        this.initStates();
        this.initCities();
        this.initBrands();
        this.initProductcategories();
        this.initProducts();
        this.initProductsubcategories();
        this.initVendorpricings();
    }
    checkSpecificationExists(prod, specname) {
        for (var spec of prod.specificationlist) {
            if (spec.name == specname)
                return true;
        }
    }
    setRelationalInfo() {
        this.globalvars = new Map();
        //Product
        for (var prod of this.productlist) {
            var brandidx = this.getIndexInMasterList(this.brandlist, prod.brandid);
            if (brandidx != -1) {
                var brand = this.brandlist[brandidx];
                prod.brandname = brand.name;
            }
            var subcatidx = this.getIndexInMasterList(this.subcategorylist, prod.subcategoryid);
            if (subcatidx != -1) {
                var subcat = this.subcategorylist[subcatidx];
                prod.subcategory = subcat;
            }
            if (!prod.specificationlist)
                prod.specificationlist = [];
            //Push blank value
            /*for(var spec of this.productspecificationlist){
              if(!this.checkSpecificationExists( prod,spec.name)){
                 prod.specificationlist.push({name: spec.name, value: ''});
              }
            }*/
        }
        //Subcat
        for (var subcat of this.subcategorylist) {
            var catidx = this.getIndexInMasterList(this.categorylist, subcat.categoryid);
            if (catidx != -1) {
                var cat = this.categorylist[catidx];
                subcat.category = cat;
            }
            //Set billing type 
            var saleexists = false;
            var rentexists = false;
            for (var prod of this.productlist) {
                if (prod.subcategoryid == subcat.id) {
                    if (prod.billingtype == 'BOTH') {
                        saleexists = true;
                        rentexists = true;
                    }
                    if (prod.billingtype == 'SALE')
                        saleexists = true;
                    if (prod.billingtype == 'RENT')
                        rentexists = true;
                }
            }
            if (saleexists && rentexists)
                subcat.billingtype = 'BOTH';
            else if (saleexists)
                subcat.billingtype = 'SALE';
            else if (rentexists)
                subcat.billingtype = 'RENT';
        }
        //City
        for (var city of this.citylist) {
            var stateidx = this.getIndexInMasterList(this.statelist, city.stateid);
            if (stateidx != -1) {
                var state = this.statelist[stateidx];
                city.statename = state.name;
            }
            if (city.billingcityid && city.billingcityid.length > 0) {
                var cityidx = this.getIndexInMasterList(this.citylist, city.billingcityid);
                if (cityidx > -1) {
                    var blngcity = this.citylist[cityidx];
                    city.billingcityname = blngcity.name;
                }
            }
        }
        for (var cat of this.categorylist) {
            //Set billing type 
            var saleexists = false;
            var rentexists = false;
            for (var subcat of this.subcategorylist) {
                if (subcat.categoryid == cat.id) {
                    if (subcat.billingtype == 'BOTH') {
                        saleexists = true;
                        rentexists = true;
                    }
                    if (subcat.billingtype == 'SALE')
                        saleexists = true;
                    if (subcat.billingtype == 'RENT')
                        rentexists = true;
                }
            }
            if (saleexists && rentexists)
                cat.billingtype = 'BOTH';
            else if (saleexists)
                cat.billingtype = 'SALE';
            else if (rentexists)
                cat.billingtype = 'RENT';
        }
        //Product pricing 
        if (this.productcitypricinglist) {
            for (var pricing of this.productcitypricinglist) {
                var prod = this.getProductForId(pricing.productid);
                if (prod) {
                    pricing.brandname = prod.brandname;
                    pricing.billingtype = prod.billingtype;
                }
            }
        }
        //this.setVendorPricingList();
    }
    getInitMasterStatus() {
        // Return if there is error 
        if (this.initerror)
            return { status: "error", statuserrorcode: Constants.INIT_MASTER_ERROR, errordescription: this.initerrordesc };
        if (this.mastersinitdone.length >= 15) {
            this.setRelationalInfo();
            return { status: "success" };
        }
        else {
            return { status: "inprogress", statuserrorcode: Math.round(this.mastersinitdone.length / 14 * 100) };
        }
    }
    getInitMasterStatusCustomer() {
        // Return if there is error 
        if (this.initerror)
            return { status: "error", statuserrorcode: Constants.INIT_MASTER_ERROR, errordescription: this.initerrordesc };
        if (this.mastersinitdone.length >= 7) {
            this.setRelationalInfo();
            return { status: "success" };
        }
        else {
            return { status: "inprogress", statuserrorcode: Math.round(this.mastersinitdone.length / 6 * 100) };
        }
    }
    getInitMasterStatusVendor() {
        // Return if there is error 
        if (this.initerror)
            return { status: "error", statuserrorcode: Constants.INIT_MASTER_ERROR, errordescription: this.initerrordesc };
        if (this.mastersinitdone.length >= 7) {
            this.setRelationalInfo();
            this.setVendorPricingList();
            return { status: "success" };
        }
        else {
            return { status: "inprogress", statuserrorcode: Math.round(this.mastersinitdone.length / 6 * 100) };
        }
    }
    checkVendorPricing(productid) {
        if (this.vendorpricinglist && this.vendorpricinglist.length > 0) {
            for (var pricing of this.vendorpricinglist) {
                if (pricing.productid == productid)
                    return pricing;
            }
        }
        return null;
    }
    getCurrentVendorPrice(vendorprice) {
        return __awaiter(this, void 0, void 0, function* () {
            var tablename = this.util.getTableName('vendorpricing');
            var key = { 'vendorid': vendorprice.vendorid, 'productid': vendorprice.productid };
            return yield this.dblib.getItem(tablename, key);
        });
    }
    getVendorPricingUnderReview() {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "getVendorPricingUnderReview++");
            var tablename = this.util.getTableName('vendorpricing');
            var conditionexpression = "availabilitystatus = :v_status";
            var attribparams = { ":v_status": 'Under Review' };
            var pricinglist = yield this.dblib.queryDB(tablename, "availabilitystatus-index", conditionexpression, null, null, attribparams, null, null, null, true, true);
            for (var price of pricinglist) {
                var vendor = this.getVendorForId(price.vendorid);
                if (vendor)
                    price.vendorname = vendor.businessname;
                var prod = this.getProductForId(price.productid);
                if (prod) {
                    price.productname = prod.name;
                    price.brandname = prod.brandname;
                    price.modelno = prod.modelno;
                    price.imagefiles = prod.imagefiles;
                    price.sortorder = prod.sortorder;
                }
                if (price.availabilitystatus == 'Available')
                    price.isenabled = true;
                else
                    price.isenabled = false;
                price.datakey = price.vendorid + price.productid;
            }
            this.util.log(Constants.LOG_DEBUG, "getVendorPricingUnderReview--");
            return pricinglist;
        });
    }
    getSubcategoriesForCategory(catid) {
        var retlist = [];
        for (var subcat of this.subcategorylist) {
            if (subcat.categoryid == catid) {
                retlist.push(subcat);
            }
        }
        return retlist;
    }
    getProductsForSubcategory(subcatid) {
        var retlist = [];
        for (var prod of this.productlist) {
            if (prod.subcategoryid == subcatid) {
                retlist.push(prod);
            }
        }
        return retlist;
    }
    getProductForId(productid) {
        for (var prod of this.productlist) {
            if (prod.id == productid)
                return prod;
        }
        return null;
    }
    getVendorForId(vendorid) {
        for (var vendor of this.vendorlist) {
            if (vendor.id == vendorid)
                return vendor;
        }
        return null;
    }
    setVendorPricingList() {
        for (var prod of this.productlist) {
            var curpricing = this.checkVendorPricing(prod.id);
            var unmapped = false;
            if (curpricing == null) {
                curpricing = {};
                var curtimestr = formatDate(this.dblib.getTime(), "YYYY-MM-dd HH:mm", "en-US");
                curpricing.productid = prod.id;
                curpricing.updatedat = curtimestr;
                curpricing.updatedby = this.loggedinvendor.businessname;
                curpricing.availabilitystatus = 'Not mapped';
                unmapped = true;
            }
            curpricing.productname = prod.name;
            curpricing.brandname = prod.brandname;
            curpricing.modelno = prod.modelno;
            curpricing.imagefiles = prod.imagefiles;
            curpricing.sortorder = prod.sortorder;
            if (curpricing.availabilitystatus == 'Available')
                curpricing.isenabled = true;
            else
                curpricing.isenabled = false;
            if (unmapped)
                this.vendorpricinglist.push(curpricing);
        }
    }
    getB2bPricing(productid, customerid, cityid) {
        for (var pricing of this.b2bcustomerpricinglist) {
            if (pricing.productid == productid && pricing.customerid == customerid && pricing.cityid == cityid) {
                return pricing;
            }
        }
        return null;
    }
    getMasterList(mastername) {
        switch (mastername) {
            case 'state': return this.statelist;
            case 'city': return this.citylist;
            case 'agent': return this.agentlist;
            case 'brand': return this.brandlist;
            case 'vendor': return this.vendorlist;
            case 'warehouse': return this.warehouselist;
            case 'product': return this.productlist;
            case 'productcategory': return this.categorylist;
            case 'productsubcategory': return this.subcategorylist;
            case 'businesscustomer': return this.businesscustomerlist;
            case 'vendorpricing': return this.vendorpricinglist;
            case 'productspecification': return this.productspecificationlist;
            case 'productcitypricing': return this.productcitypricinglist;
            case 'user': return this.userlist;
            case 'usergroup': return this.usergrouplist;
            case 'b2bcustomerpricing': return this.b2bcustomerpricinglist;
        }
    }
    getIndexInMasterList(masterlist, id) {
        for (let i = 0; i < masterlist.length; i++) {
            if (masterlist[i].id === id) {
                return i;
            }
        }
        return -1;
    }
    /**********
     * updates in the masters
     */
    updateMasterList(mastername, dmltype, updatedobject, deletedobjects) {
        var masterlist = this.getMasterList(mastername);
        switch (dmltype) {
            case 'create':
                masterlist.push(updatedobject);
                break;
            case 'edit':
                var index = this.getIndexInMasterList(masterlist, updatedobject.id);
                if (index >= 0)
                    masterlist[index] = updatedobject;
                break;
            case 'delete':
                for (var obj of deletedobjects) {
                    var index = this.getIndexInMasterList(masterlist, obj.id);
                    if (index >= 0)
                        masterlist.splice(index, 1);
                }
                break;
        }
    }
}
AppdataService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AppdataService, deps: [{ token: i3.DynamoLibService }, { token: PrivilegeService }, { token: UtilService }], target: i0.ɵɵFactoryTarget.Injectable });
AppdataService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AppdataService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AppdataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i3.DynamoLibService }, { type: PrivilegeService }, { type: UtilService }]; } });

class AuditService {
    constructor(dataService, util, dynamoLib) {
        this.dataService = dataService;
        this.util = util;
        this.dynamoLib = dynamoLib;
    }
    getUpdateAuditLogs(item) {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "getUpdateAuditLogs++");
            var retarr = [];
            if (item.last10updates && item.last10updates.length > 0) {
                for (var logid of item.last10updates) {
                    var log = yield this.dynamoLib.getItem(this.util.getTableName('setupaudittrail'), { "id": logid });
                    if (log)
                        retarr.push(log);
                }
            }
            this.util.log(Constants.LOG_DEBUG, "getUpdateAuditLogs--");
            return retarr;
        });
    }
    getUsergroupAuditTrail(usergroup) {
        this.util.log(Constants.LOG_DEBUG, "getUsergroupAuditTrail++");
        var index = this.dataService.getIndexInMasterList(this.dataService.usergrouplist, usergroup.id);
        this.util.log(Constants.LOG_DEBUG, "getUsergroupAuditTrail Index " + index);
        if (index >= 0) {
            var curusergroup = this.dataService.usergrouplist[index];
            var updatedetails = [];
            if (curusergroup.name != usergroup.name)
                updatedetails.push('Usergroup name changed from: ' + curusergroup.name + ' To ' + usergroup.name);
            if (curusergroup.privilegestring != usergroup.privilegestring)
                updatedetails.push('Privileges changed from: ' + curusergroup.privilegestring + ' To ' + usergroup.privilegestring);
            if (updatedetails.length > 0) {
                var auditlog = {};
                auditlog.id = "" + this.dynamoLib.getTime();
                auditlog.mastername = 'usergroup';
                auditlog.entityrefid = usergroup.id;
                auditlog.businessdate = this.util.getCurrentBusinessDate();
                auditlog.versionafter = usergroup.objectversion;
                auditlog.versionbefore = curusergroup.objectversion;
                auditlog.entityrefname = usergroup.name;
                auditlog.updatetype = 'edit';
                auditlog.updatedetails = updatedetails;
                if (!usergroup.last10updates)
                    usergroup.last10updates = [];
                usergroup.last10updates.push(auditlog.id);
                return auditlog;
            }
        }
        return null;
    }
    getUserAuditTrail(user) {
        this.util.log(Constants.LOG_DEBUG, "getUserAuditTrail++");
        var index = this.dataService.getIndexInMasterList(this.dataService.userlist, user.id);
        this.util.log(Constants.LOG_DEBUG, "getUserAuditTrail Index " + index);
        if (index >= 0) {
            var curuser = this.dataService.userlist[index];
            var updatedetails = [];
            if (curuser.name != user.name)
                updatedetails.push('Name changed from: ' + curuser.name + ' To ' + user.name);
            if (curuser.username != user.username)
                updatedetails.push('Username changed from: ' + curuser.username + ' To ' + user.username);
            if (curuser.userpass != user.userpass)
                updatedetails.push('Password modified');
            if (curuser.active != user.active)
                updatedetails.push('User active status changed from ' + curuser.active + ' To ' + user.active);
            if (curuser.usergroupname != user.usergroupname)
                updatedetails.push('Usergroup changed from: ' + curuser.usergroupname + ' To ' + user.usergroupname);
            if (updatedetails.length > 0) {
                var auditlog = {};
                auditlog.id = "" + this.dynamoLib.getTime();
                auditlog.mastername = 'user';
                auditlog.entityrefid = user.id;
                auditlog.businessdate = this.util.getCurrentBusinessDate();
                auditlog.versionafter = user.objectversion;
                auditlog.versionbefore = curuser.objectversion;
                auditlog.entityrefname = user.name;
                auditlog.updatetype = 'edit';
                auditlog.updatedetails = updatedetails;
                if (!user.last10updates)
                    user.last10updates = [];
                user.last10updates.push(auditlog.id);
                return auditlog;
            }
        }
        return null;
    }
    getStateAuditTrail(state) {
        this.util.log(Constants.LOG_DEBUG, "getStateAuditTrail++ " + state.name + ' id ' + state.id);
        var index = this.dataService.getIndexInMasterList(this.dataService.statelist, state.id);
        this.util.log(Constants.LOG_DEBUG, "getStateAuditTrail Index " + index);
        if (index >= 0) {
            var curstate = this.dataService.statelist[index];
            if (curstate.name != state.name) {
                var auditlog = {};
                auditlog.id = "" + this.dynamoLib.getTime();
                auditlog.mastername = 'state';
                auditlog.entityrefid = state.id;
                auditlog.businessdate = this.util.getCurrentBusinessDate();
                auditlog.versionafter = state.objectversion;
                auditlog.versionbefore = curstate.objectversion;
                auditlog.entityrefname = state.name;
                auditlog.updatetype = 'edit';
                auditlog.updatedetails = [];
                auditlog.updatedetails.push('State name changed from: ' + curstate.name + ' To ' + state.name);
                if (!state.last10updates)
                    state.last10updates = [];
                state.last10updates.push(auditlog.id);
                return auditlog;
            }
        }
        return null;
    }
    getCityAuditTrail(city) {
        var index = this.dataService.getIndexInMasterList(this.dataService.citylist, city.id);
        if (index >= 0) {
            var curcity = this.dataService.citylist[index];
            if (curcity.name != city.name || curcity.stateid != city.stateid) {
                var auditlog = {};
                auditlog.id = "" + this.dynamoLib.getTime();
                auditlog.mastername = 'city';
                auditlog.entityrefid = city.id;
                auditlog.businessdate = this.util.getCurrentBusinessDate();
                auditlog.versionafter = city.objectversion;
                auditlog.versionbefore = curcity.objectversion;
                auditlog.entityrefname = city.name;
                auditlog.updatetype = 'edit';
                auditlog.updatedetails = [];
                if (curcity.name != city.name)
                    auditlog.updatedetails.push('City name changed from: ' + curcity.name + ' To ' + city.name);
                if (curcity.stateid != city.stateid)
                    auditlog.updatedetails.push('State changed from: ' + curcity.statename + ' To ' + city.statename);
                if (!city.last10updates)
                    city.last10updates = [];
                city.last10updates.push(auditlog.id);
                return auditlog;
            }
        }
        return null;
    }
    getProductcategoryAuditTrail(productcategory) {
        var index = this.dataService.getIndexInMasterList(this.dataService.categorylist, productcategory.id);
        if (index >= 0) {
            var curproductcategory = this.dataService.categorylist[index];
            var updatedetails = [];
            if (curproductcategory.name != productcategory.name)
                updatedetails.push('Category name changed from: ' + curproductcategory.name + ' To ' + productcategory.name);
            if (curproductcategory.code != productcategory.code)
                updatedetails.push('Category code changed from: ' + curproductcategory.code + ' To ' + productcategory.code);
            if (curproductcategory.description != productcategory.description)
                updatedetails.push('Category code changed from: ' + curproductcategory.description + ' To ' + productcategory.description);
            if (curproductcategory.hideonweb != productcategory.hideonweb)
                updatedetails.push('Hide on web changed from: ' + curproductcategory.hideonweb + ' To ' + productcategory.hideonweb);
            if (JSON.stringify(curproductcategory.translations) != JSON.stringify(productcategory.translations))
                updatedetails.push('Changes made to translations.');
            if (updatedetails.length > 0) {
                var auditlog = {};
                auditlog.id = "" + this.dynamoLib.getTime();
                auditlog.mastername = 'productcategory';
                auditlog.entityrefid = productcategory.id;
                auditlog.businessdate = this.util.getCurrentBusinessDate();
                auditlog.versionafter = productcategory.objectversion;
                auditlog.versionbefore = curproductcategory.objectversion;
                auditlog.entityrefname = productcategory.name;
                auditlog.updatetype = 'edit';
                auditlog.updatedetails = updatedetails;
                if (!productcategory.last10updates)
                    productcategory.last10updates = [];
                productcategory.last10updates.push(auditlog.id);
                return auditlog;
            }
        }
        return null;
    }
    getProductsubcategoryAuditTrail(productsubcategory) {
        var index = this.dataService.getIndexInMasterList(this.dataService.subcategorylist, productsubcategory.id);
        if (index >= 0) {
            var curproductsubcategory = this.dataService.subcategorylist[index];
            var updatedetails = [];
            if (curproductsubcategory.name != productsubcategory.name)
                updatedetails.push('Subcategory name changed from: ' + curproductsubcategory.name + ' To ' + productsubcategory.name);
            if (curproductsubcategory.code != productsubcategory.code)
                updatedetails.push('Subcategory code changed from: ' + curproductsubcategory.code + ' To ' + productsubcategory.code);
            if (curproductsubcategory.categoryid != productsubcategory.categoryid)
                updatedetails.push('Category changed from: ' + curproductsubcategory.category.name + ' To ' + productsubcategory.category.name);
            if (curproductsubcategory.hideonweb != productsubcategory.hideonweb)
                updatedetails.push('Hide on web changed from: ' + curproductsubcategory.hideonweb + ' To ' + productsubcategory.hideonweb);
            if (JSON.stringify(curproductsubcategory.translations) != JSON.stringify(productsubcategory.translations))
                updatedetails.push('Changes made to translations.');
            if (updatedetails.length > 0) {
                var auditlog = {};
                auditlog.id = "" + this.dynamoLib.getTime();
                auditlog.mastername = 'productsubcategory';
                auditlog.entityrefid = productsubcategory.id;
                auditlog.businessdate = this.util.getCurrentBusinessDate();
                auditlog.versionafter = productsubcategory.objectversion;
                auditlog.versionbefore = curproductsubcategory.objectversion;
                auditlog.entityrefname = productsubcategory.name;
                auditlog.updatetype = 'edit';
                auditlog.updatedetails = updatedetails;
                if (!productsubcategory.last10updates)
                    productsubcategory.last10updates = [];
                productsubcategory.last10updates.push(auditlog.id);
                return auditlog;
            }
        }
        return null;
    }
    getVendorPriceAuditTrail(vendorprice) {
        return __awaiter(this, void 0, void 0, function* () {
            var curvendorprice = this.dataService.checkVendorPricing(vendorprice.productid);
            if (!curvendorprice) {
                curvendorprice = (yield this.dataService.getCurrentVendorPrice(vendorprice));
            }
            if (curvendorprice) {
                var updatedetails = [];
                if (curvendorprice.availabilitystatus != vendorprice.availabilitystatus) {
                    updatedetails.push('Product name changed from: ' + curvendorprice.availabilitystatus + ' To ' + vendorprice.availabilitystatus);
                }
                if (curvendorprice.weeklyrent != vendorprice.weeklyrent) {
                    updatedetails.push('Weekly rent changed from : ' + curvendorprice.weeklyrent + ' To ' + vendorprice.weeklyrent);
                }
                if (curvendorprice.monthlyrent != vendorprice.monthlyrent) {
                    updatedetails.push('Monthly rent changed from : ' + curvendorprice.monthlyrent + ' To ' + vendorprice.monthlyrent);
                }
                if (curvendorprice.depositforrent != vendorprice.depositforrent) {
                    updatedetails.push('Deposit for rent changed from : ' + curvendorprice.depositforrent + ' To ' + vendorprice.depositforrent);
                }
                if (curvendorprice.sellingprice != vendorprice.sellingprice) {
                    updatedetails.push('Selling price changed from : ' + curvendorprice.sellingprice + ' To ' + vendorprice.sellingprice);
                }
                if (curvendorprice.availabilitytype != vendorprice.availabilitytype) {
                    updatedetails.push('Availability type changed from: ' + curvendorprice.availabilitytype + ' To ' + vendorprice.availabilitytype);
                }
                if (updatedetails.length > 0) {
                    var auditlog = {};
                    auditlog.id = "" + this.dynamoLib.getTime();
                    auditlog.vendorid = vendorprice.vendorid;
                    auditlog.vendorname = vendorprice.vendorname;
                    auditlog.productid = vendorprice.productid;
                    auditlog.productname = vendorprice.productname;
                    auditlog.businessdate = this.util.getCurrentBusinessDate();
                    auditlog.versionafter = vendorprice.objectversion;
                    auditlog.versionbefore = curvendorprice.objectversion;
                    auditlog.updatetype = 'edit';
                    auditlog.updatedetails = updatedetails;
                    if (!vendorprice.last10updates)
                        vendorprice.last10updates = [];
                    vendorprice.last10updates.push(auditlog.id);
                    return auditlog;
                }
            }
        });
    }
    getProductAuditTrail(product) {
        var index = this.dataService.getIndexInMasterList(this.dataService.productlist, product.id);
        if (index >= 0) {
            var curproduct = this.dataService.productlist[index];
            var updatedetails = [];
            if (curproduct.name != product.name)
                updatedetails.push('Product name changed from: ' + curproduct.name + ' To ' + product.name);
            if (curproduct.subcategoryid != product.subcategoryid)
                updatedetails.push('Product subcategory changed from: ' + curproduct.subcategory.name + ' To ' + product.subcategory.name);
            if (curproduct.categoryid != product.categoryid)
                updatedetails.push('Product category changed from: ' + curproduct.categoryname + ' To ' + product.categoryname);
            if (curproduct.billingtype != product.billingtype)
                updatedetails.push('Billing type changed from: ' + curproduct.billingtype + ' To ' + product.billingtype);
            if (curproduct.brandid != product.brandid)
                updatedetails.push('Brand changed from: ' + curproduct.brandname + ' To ' + product.brandname);
            if (curproduct.introductionline != product.introductionline)
                updatedetails.push('Product introduction line changed from: ' + curproduct.introductionline + ' To ' + product.introductionline);
            if (curproduct.modelno != product.modelno)
                updatedetails.push('Product model no changed from: ' + curproduct.modelno + ' To ' + product.modelno);
            if (curproduct.gstpercentage != product.gstpercentage)
                updatedetails.push('Product GST Percentage changed from: ' + curproduct.gstpercentage + ' To ' + product.gstpercentage);
            if (curproduct.gstpercentagerent != product.gstpercentagerent)
                updatedetails.push('Product GST Percentage (Rent) changed from: ' + curproduct.gstpercentagerent + ' To ' + product.gstpercentagerent);
            if (curproduct.hideonweb != product.hideonweb)
                updatedetails.push('Hide on web changed from: ' + curproduct.hideonweb + ' To ' + product.hideonweb);
            //** Product pricing changes
            if (curproduct.productpricing.retailsellingrate != product.productpricing.retailsellingrate)
                updatedetails.push('Customer selling price changed from: ' + curproduct.productpricing.retailsellingrate + ' To ' + product.productpricing.retailsellingrate);
            if (curproduct.productpricing.partnersellingrate != product.productpricing.partnersellingrate)
                updatedetails.push('Agent  selling price changed from: ' + curproduct.productpricing.partnersellingrate + ' To ' + product.productpricing.partnersellingrate);
            if (curproduct.productpricing.bulksellingrate != product.productpricing.bulksellingrate)
                updatedetails.push('Business customer selling price changed from: ' + curproduct.productpricing.bulksellingrate + ' To ' + product.productpricing.bulksellingrate);
            if (curproduct.productpricing.retailmonthlyrent != product.productpricing.retailmonthlyrent)
                updatedetails.push('Customer monthly rent changed from: ' + curproduct.productpricing.retailmonthlyrent + ' To ' + product.productpricing.retailmonthlyrent);
            if (curproduct.productpricing.partnermonthlyrent != product.productpricing.partnermonthlyrent)
                updatedetails.push('Agent customer monthly rent changed from: ' + curproduct.productpricing.partnermonthlyrent + ' To ' + product.productpricing.partnermonthlyrent);
            if (curproduct.productpricing.bulkmonthlyrent != product.productpricing.bulkmonthlyrent)
                updatedetails.push('Business customer monthly rent changed from: ' + curproduct.productpricing.bulkmonthlyrent + ' To ' + product.productpricing.bulkmonthlyrent);
            if (curproduct.productpricing.retailweeklyrent != product.productpricing.retailweeklyrent)
                updatedetails.push('Customer weekly rent changed from: ' + curproduct.productpricing.retailweeklyrent + ' To ' + product.productpricing.retailweeklyrent);
            if (curproduct.productpricing.partnerweeklyrent != product.productpricing.partnerweeklyrent)
                updatedetails.push('Agent customer weekly rent changed from: ' + curproduct.productpricing.partnerweeklyrent + ' To ' + product.productpricing.partnerweeklyrent);
            if (curproduct.productpricing.bulkweeklyrent != product.productpricing.bulkweeklyrent)
                updatedetails.push('Business customer weekly rent changed from: ' + curproduct.productpricing.bulkweeklyrent + ' To ' + product.productpricing.bulkweeklyrent);
            if (curproduct.productpricing.depositforrent != product.productpricing.depositforrent)
                updatedetails.push('Deposit for rent changed from: ' + curproduct.productpricing.depositforrent + ' To ' + product.productpricing.depositforrent);
            if (JSON.stringify(curproduct.translations) != JSON.stringify(product.translations))
                updatedetails.push('Changes made to translations.');
            if (updatedetails.length > 0) {
                var auditlog = {};
                auditlog.id = "" + this.dynamoLib.getTime();
                auditlog.mastername = 'product';
                auditlog.entityrefid = product.id;
                auditlog.businessdate = this.util.getCurrentBusinessDate();
                auditlog.versionafter = product.objectversion;
                auditlog.versionbefore = curproduct.objectversion;
                auditlog.entityrefname = product.name;
                auditlog.updatetype = 'edit';
                auditlog.updatedetails = updatedetails;
                if (!product.last10updates)
                    product.last10updates = [];
                product.last10updates.push(auditlog.id);
                return auditlog;
            }
        }
        return null;
    }
    getBrandAuditTrail(brand) {
        var index = this.dataService.getIndexInMasterList(this.dataService.brandlist, brand.id);
        if (index >= 0) {
            var curbrand = this.dataService.brandlist[index];
            var updatedetails = [];
            if (curbrand.name != brand.name)
                updatedetails.push('Brand name changed from: ' + curbrand.name + ' To ' + brand.name);
            if (updatedetails.length > 0) {
                var auditlog = {};
                auditlog.id = "" + this.dynamoLib.getTime();
                auditlog.mastername = 'brand';
                auditlog.entityrefid = brand.id;
                auditlog.businessdate = this.util.getCurrentBusinessDate();
                auditlog.versionafter = brand.objectversion;
                auditlog.versionbefore = curbrand.objectversion;
                auditlog.entityrefname = brand.name;
                auditlog.updatetype = 'edit';
                auditlog.updatedetails = updatedetails;
                if (!brand.last10updates)
                    brand.last10updates = [];
                brand.last10updates.push(auditlog.id);
                return auditlog;
            }
        }
        return null;
    }
    getProductspecificationAuditTrail(productspecification) {
        var index = this.dataService.getIndexInMasterList(this.dataService.productspecificationlist, productspecification.id);
        if (index >= 0) {
            var curproductspecification = this.dataService.productspecificationlist[index];
            var updatedetails = [];
            if (curproductspecification.name != productspecification.name)
                updatedetails.push('Productspecification name changed from: ' + curproductspecification.name + ' To ' + productspecification.name);
            if (updatedetails.length > 0) {
                var auditlog = {};
                auditlog.id = "" + this.dynamoLib.getTime();
                auditlog.mastername = 'productspecification';
                auditlog.entityrefid = productspecification.id;
                auditlog.businessdate = this.util.getCurrentBusinessDate();
                auditlog.versionafter = productspecification.objectversion;
                auditlog.versionbefore = curproductspecification.objectversion;
                auditlog.entityrefname = productspecification.name;
                auditlog.updatetype = 'edit';
                auditlog.updatedetails = updatedetails;
                if (!productspecification.last10updates)
                    productspecification.last10updates = [];
                productspecification.last10updates.push(auditlog.id);
                return auditlog;
            }
        }
        return null;
    }
    getVendorAuditTrail(vendor) {
        var index = this.dataService.getIndexInMasterList(this.dataService.vendorlist, vendor.id);
        if (index >= 0) {
            var curvendor = this.dataService.vendorlist[index];
            var updatedetails = [];
            if (curvendor.businessname != vendor.businessname)
                updatedetails.push('Vendor name changed from: ' + curvendor.businessname + ' To ' + vendor.businessname);
            if (curvendor.contactperson != vendor.contactperson)
                updatedetails.push('Vendor contact person name changed from: ' + curvendor.contactperson + ' To ' + vendor.contactperson);
            if (curvendor.vendortag != vendor.vendortag)
                updatedetails.push('Vendor tag name changed from: ' + curvendor.vendortag + ' To ' + vendor.vendortag);
            if (curvendor.contactnumbers != vendor.contactnumbers)
                updatedetails.push('vendor contact number changed from: ' + curvendor.contactnumbers + ' To ' + vendor.contactnumbers);
            if (curvendor.whatasappnummber != vendor.whatasappnummber)
                updatedetails.push('vendor whatsapp number changed from: ' + curvendor.whatasappnummber + ' To ' + vendor.whatasappnummber);
            if (curvendor.cityname != vendor.cityname)
                updatedetails.push('Vendor city changed from: ' + curvendor.cityname + ' To ' + vendor.cityname);
            if (curvendor.statename != vendor.statename)
                updatedetails.push('Vendor state changed from: ' + curvendor.statename + ' To ' + vendor.statename);
            if (JSON.stringify(curvendor.accountinfo) != JSON.stringify(vendor.accountinfo))
                updatedetails.push('Vendor Account Information changed from: ' + JSON.stringify(curvendor.accountinfo) + ' To ' + JSON.stringify(vendor.accountinfo));
            if (curvendor.panno != vendor.panno)
                updatedetails.push('vendor pan number changed from: ' + curvendor.panno + ' To ' + vendor.panno);
            if (curvendor.gstinno != vendor.gstinno)
                updatedetails.push('vendor gstin number changed from: ' + curvendor.gstinno + ' To ' + vendor.gstinno);
            if (JSON.stringify(curvendor.registeredaddress) != JSON.stringify(vendor.registeredaddress))
                updatedetails.push('Vendor address  Changed from: ' + JSON.stringify(curvendor.registeredaddress) + ' To ' + JSON.stringify(vendor.registeredaddress));
            if (JSON.stringify(curvendor.warehouseaddresses) != JSON.stringify(vendor.warehouseaddresses))
                updatedetails.push('Changes made to warehouse addresses');
            if (curvendor.vendortag != vendor.vendortag)
                updatedetails.push('Vendor tag  changed from: ' + curvendor.vendortag + ' To ' + vendor.vendortag);
            if (updatedetails.length > 0) {
                var auditlog = {};
                auditlog.id = "" + this.dynamoLib.getTime();
                auditlog.mastername = 'vendor';
                auditlog.entityrefid = vendor.id;
                auditlog.businessdate = this.util.getCurrentBusinessDate();
                auditlog.versionafter = vendor.objectversion;
                auditlog.versionbefore = curvendor.objectversion;
                auditlog.entityrefname = vendor.businessname;
                auditlog.updatetype = 'edit';
                auditlog.updatedetails = updatedetails;
                if (!vendor.last10updates)
                    vendor.last10updates = [];
                vendor.last10updates.push(auditlog.id);
                return auditlog;
            }
        }
        return null;
    }
    getAgentAuditTrail(agent) {
        var index = this.dataService.getIndexInMasterList(this.dataService.agentlist, agent.id);
        if (index >= 0) {
            var curagent = this.dataService.agentlist[index];
            var updatedetails = [];
            if (curagent.agentname != agent.agentname)
                updatedetails.push('Agent name changed from: ' + curagent.agentname + ' To ' + agent.agentname);
            if (curagent.agenttag != agent.agenttag)
                updatedetails.push('Agent tag name changed from: ' + curagent.agenttag + ' To ' + agent.agenttag);
            if (curagent.contactperson != agent.contactperson)
                updatedetails.push('Agent contact person name changed from: ' + curagent.contactperson + ' To ' + agent.contactperson);
            if (curagent.contactnumbers != agent.contactnumbers)
                updatedetails.push('Agent contact number changed from: ' + curagent.contactnumbers + ' To ' + agent.contactnumbers);
            if (curagent.whatasappnummber != agent.whatasappnummber)
                updatedetails.push('Agent whatsapp number changed from: ' + curagent.whatasappnummber + ' To ' + agent.whatasappnummber);
            if (JSON.stringify(curagent.accountinfo) != JSON.stringify(agent.accountinfo))
                updatedetails.push('Agent accountinfo changed from: ' + JSON.stringify(curagent.accountinfo) + ' To ' + JSON.stringify(agent.accountinfo));
            if (JSON.stringify(curagent.agentaddress) != JSON.stringify(agent.agentaddress))
                updatedetails.push('Agent address changed from: ' + JSON.stringify(curagent.agentaddress) + ' To ' + JSON.stringify(agent.agentaddress));
            if (curagent.panno != agent.panno)
                updatedetails.push('Agent PAN number changed from: ' + curagent.panno + ' To ' + agent.panno);
            if (curagent.gstinno != agent.gstinno)
                updatedetails.push('Agent GSTIN number changed from: ' + curagent.gstinno + ' To ' + agent.gstinno);
            if (curagent.maxmarginpercentage != agent.maxmarginpercentage)
                updatedetails.push('Agent Margin Percentaage changed from: ' + curagent.maxmarginpercentage + ' To ' + agent.maxmarginpercentage);
            if (updatedetails.length > 0) {
                var auditlog = {};
                auditlog.id = "" + this.dynamoLib.getTime();
                auditlog.mastername = 'agent';
                auditlog.entityrefid = agent.id;
                auditlog.businessdate = this.util.getCurrentBusinessDate();
                auditlog.versionafter = agent.objectversion;
                auditlog.versionbefore = curagent.objectversion;
                auditlog.entityrefname = agent.agentname;
                auditlog.updatetype = 'edit';
                auditlog.updatedetails = updatedetails;
                if (!agent.last10updates)
                    agent.last10updates = [];
                agent.last10updates.push(auditlog.id);
                return auditlog;
            }
        }
        return null;
    }
    getOrderAuditTrail(originalOrder, updatedOrder) {
        var updatedetails = [];
        if (originalOrder.curstatus != updatedOrder.curstatus)
            updatedetails.push('Status changed from: ' + originalOrder.curstatus + ' To ' + updatedOrder.curstatus);
        if (originalOrder.cart.sumitemcount != updatedOrder.cart.sumitemcount)
            updatedetails.push('Num of items changed from: ' + originalOrder.cart.sumitemcount + ' To ' + updatedOrder.cart.sumitemcount);
        if (originalOrder.cart.netpayable != updatedOrder.cart.netpayable)
            updatedetails.push('Net payable changed from: ' + originalOrder.cart.netpayable + ' To ' + updatedOrder.cart.netpayable);
        if (originalOrder.cart.sumitemdiscountvalue != updatedOrder.cart.sumitemdiscountvalue)
            updatedetails.push('Discount changed from: ' + originalOrder.cart.sumitemdiscountvalue + ' To ' + updatedOrder.cart.sumitemdiscountvalue);
        if (updatedetails.length > 0) {
            var auditlog = {};
            auditlog.id = "" + this.dynamoLib.getTime();
            auditlog.mastername = 'warehouse';
            auditlog.entityrefid = originalOrder.id;
            auditlog.businessdate = this.util.getCurrentBusinessDate();
            auditlog.versionafter = originalOrder.objectversion;
            auditlog.versionbefore = updatedOrder.objectversion;
            auditlog.updatetype = 'edit';
            auditlog.updatedetails = updatedetails;
            if (!updatedOrder.last10updates)
                updatedOrder.last10updates = [];
            updatedOrder.last10updates.push(auditlog.id);
            return auditlog;
        }
    }
    getProductcitypricingAuditTrail(pricing) {
        var index = this.dataService.getIndexInMasterList(this.dataService.productcitypricinglist, pricing.cityid);
        if (index >= 0) {
            var curpricing = this.dataService.productcitypricinglist[index];
            var updatedetails = [];
            if (curpricing.cityname != pricing.cityname)
                updatedetails.push('City changed from: ' + curpricing.cityname + ' To ' + pricing.cityname);
            if (curpricing.productname != pricing.productname)
                updatedetails.push('Product changed from: ' + curpricing.productname + ' To ' + pricing.productname);
            if (curpricing.pricingtype != pricing.pricingtype)
                updatedetails.push('Pricing type from: ' + curpricing.pricingtype + ' To ' + pricing.pricingtype);
            if (curpricing.relativeinpercentrent != pricing.relativeinpercentrent)
                updatedetails.push('Relative in percent changed from: ' + curpricing.relativeinpercentrent + ' To ' + pricing.relativeinpercentrent);
            if (curpricing.escalationvaluerent != pricing.escalationvaluerent)
                updatedetails.push('Escalation value  changed from: ' + curpricing.escalationvaluerent + ' To ' + pricing.escalationvaluerent);
            if (curpricing.relativeinpercentsale != pricing.relativeinpercentsale)
                updatedetails.push('Relative in percent changed from: ' + curpricing.relativeinpercentsale + ' To ' + pricing.relativeinpercentsale);
            if (curpricing.escalationvaluerent != pricing.escalationvaluerent)
                updatedetails.push('Escalation value  changed from: ' + curpricing.escalationvaluesale + ' To ' + pricing.escalationvaluesale);
            if (JSON.stringify(curpricing.citypricing) != JSON.stringify(pricing.citypricing))
                updatedetails.push('Pricing value  changed from: ' + JSON.stringify(curpricing.citypricing) + ' To ' + JSON.stringify(pricing.citypricing));
            if (updatedetails.length > 0) {
                var auditlog = {};
                auditlog.id = "" + this.dynamoLib.getTime();
                auditlog.mastername = 'productcitypricing';
                return auditlog;
            }
        }
        return null;
    }
    getWarehouseAuditTrail(warehouse) {
        var index = this.dataService.getIndexInMasterList(this.dataService.warehouselist, warehouse.id);
        if (index >= 0) {
            var curwarehouse = this.dataService.warehouselist[index];
            var updatedetails = [];
            if (curwarehouse.name != warehouse.name)
                updatedetails.push('Warehouse name changed from: ' + curwarehouse.name + ' To ' + warehouse.name);
            if (curwarehouse.cityname != warehouse.cityname)
                updatedetails.push('Warehouse city changed from: ' + curwarehouse.cityname + ' To ' + warehouse.cityname);
            if (curwarehouse.statename != warehouse.statename)
                updatedetails.push('Warehouse state changed from: ' + curwarehouse.statename + ' To ' + warehouse.statename);
            if (curwarehouse.managercontactnumbers != warehouse.managercontactnumbers)
                updatedetails.push('Warehouse manager contactnumbers changed from: ' + curwarehouse.managercontactnumbers + ' To ' + warehouse.managercontactnumbers);
            if (curwarehouse.warehouseemail != warehouse.warehouseemail)
                updatedetails.push('Warehouse email changed from: ' + curwarehouse.warehouseemail + ' To ' + warehouse.warehouseemail);
            if (curwarehouse.warehousewhatsappnumbers != warehouse.warehousewhatsappnumbers)
                updatedetails.push('Warehouse whatsappnumber changed from: ' + curwarehouse.warehousewhatsappnumbers + ' To ' + warehouse.warehousewhatsappnumbers);
            if (curwarehouse.managername != warehouse.managername)
                updatedetails.push('Warehouse manager name changed from: ' + curwarehouse.managername + ' To ' + warehouse.managername);
            if (JSON.stringify(curwarehouse.address) != JSON.stringify(warehouse.address))
                updatedetails.push('Warehouse address changed from: ' + JSON.stringify(curwarehouse.address) + ' To ' + JSON.stringify(warehouse.address));
            if (updatedetails.length > 0) {
                var auditlog = {};
                auditlog.id = "" + this.dynamoLib.getTime();
                auditlog.mastername = 'warehouse';
                auditlog.entityrefid = warehouse.id;
                auditlog.businessdate = this.util.getCurrentBusinessDate();
                auditlog.versionafter = warehouse.objectversion;
                auditlog.versionbefore = curwarehouse.objectversion;
                auditlog.entityrefname = warehouse.name;
                auditlog.updatetype = 'edit';
                auditlog.updatedetails = updatedetails;
                if (!warehouse.last10updates)
                    warehouse.last10updates = [];
                warehouse.last10updates.push(auditlog.id);
                return auditlog;
            }
        }
        return null;
    }
    getCustomerAuditTrail(customer) {
        return null;
    }
    getBusinesscustomerAuditTrail(businesscustomer) {
        var index = this.dataService.getIndexInMasterList(this.dataService.businesscustomerlist, businesscustomer.id);
        if (index >= 0) {
            var curbusinesscustomer = this.dataService.businesscustomerlist[index];
            var updatedetails = [];
            if (curbusinesscustomer.orgname != businesscustomer.orgname)
                updatedetails.push('Business customer name changed from: ' + curbusinesscustomer.orgname + ' To ' + businesscustomer.orgname);
            if (curbusinesscustomer.description != businesscustomer.description)
                updatedetails.push('Business customer descripiton changed from: ' + curbusinesscustomer.description + ' To ' + businesscustomer.description);
            if (JSON.stringify(curbusinesscustomer.accountinfo) != JSON.stringify(businesscustomer.accountinfo))
                updatedetails.push('Business customer account information changed from: ' + JSON.stringify(curbusinesscustomer.accountinfo) + ' To ' + JSON.stringify(businesscustomer.accountinfo));
            if (JSON.stringify(curbusinesscustomer.address) != JSON.stringify(businesscustomer.address))
                updatedetails.push('Address changed from: ' + JSON.stringify(curbusinesscustomer.address) + ' To ' + JSON.stringify(businesscustomer.address));
            if (curbusinesscustomer.contactpersons != businesscustomer.contactpersons)
                updatedetails.push('Business customer contactpersons name changed from: ' + curbusinesscustomer.contactpersons + ' To ' + businesscustomer.contactpersons);
            if (curbusinesscustomer.contactnos != businesscustomer.contactnos)
                updatedetails.push('Business customer contactno changed from: ' + curbusinesscustomer.contactnos + ' To ' + businesscustomer.contactnos);
            if (curbusinesscustomer.whatasappnummber != businesscustomer.whatasappnummber)
                updatedetails.push('Business customer whatasappnummber changed from: ' + curbusinesscustomer.whatasappnummber + ' To ' + businesscustomer.whatasappnummber);
            if (curbusinesscustomer.email != businesscustomer.email)
                updatedetails.push('Business customer email changed from: ' + curbusinesscustomer.email + ' To ' + businesscustomer.email);
            if (curbusinesscustomer.gstinno != businesscustomer.gstinno)
                updatedetails.push('Business customer gstinno changed from: ' + curbusinesscustomer.gstinno + ' To ' + businesscustomer.gstinno);
            if (updatedetails.length > 0) {
                var auditlog = {};
                auditlog.id = "" + this.dynamoLib.getTime();
                auditlog.mastername = 'businesscustomer';
                auditlog.entityrefid = businesscustomer.id;
                auditlog.businessdate = this.util.getCurrentBusinessDate();
                auditlog.versionafter = businesscustomer.objectversion;
                auditlog.versionbefore = curbusinesscustomer.objectversion;
                auditlog.entityrefname = businesscustomer.orgname;
                auditlog.updatetype = 'edit';
                auditlog.updatedetails = updatedetails;
                if (!businesscustomer.last10updates)
                    businesscustomer.last10updates = [];
                businesscustomer.last10updates.push(auditlog.id);
                return auditlog;
            }
        }
        return null;
    }
    getB2bcustomerpricingAuditTrail(pricing) {
        var index = this.dataService.getIndexInMasterList(this.dataService.b2bcustomerpricinglist, pricing.id);
        if (index >= 0) {
            var curpricing = this.dataService.b2bcustomerpricinglist[index];
            var updatedetails = [];
            if (curpricing.productid != pricing.productid)
                updatedetails.push('Product changed from: ' + curpricing.productname + ' To ' + pricing.productname);
            if (curpricing.customerid != pricing.customerid)
                updatedetails.push('Customer changed from: ' + curpricing.customername + ' To ' + pricing.customername);
            if (curpricing.dailyrent != pricing.dailyrent)
                updatedetails.push('Daily rent changed from: ' + curpricing.dailyrent + ' To ' + pricing.dailyrent);
            if (curpricing.weeklyrent != pricing.weeklyrent)
                updatedetails.push('Weekly rent changed from: ' + curpricing.weeklyrent + ' To ' + pricing.weeklyrent);
            if (curpricing.monthlyrent != pricing.monthlyrent)
                updatedetails.push('Monthly rent changed from: ' + curpricing.monthlyrent + ' To ' + pricing.monthlyrent);
            if (curpricing.sellingrate != pricing.sellingrate)
                updatedetails.push('Selling rate changed from: ' + curpricing.sellingrate + ' To ' + pricing.sellingrate);
            if (curpricing.depositforrent != pricing.depositforrent)
                updatedetails.push('Deposit for rent changed from: ' + curpricing.depositforrent + ' To ' + pricing.depositforrent);
            if (curpricing.transportationcost != pricing.transportationcost)
                updatedetails.push('Transportation cost changed from: ' + curpricing.transportationcost + ' To ' + pricing.transportationcost);
            if (curpricing.outskirttransportationcost != pricing.outskirttransportationcost)
                updatedetails.push('Outskirts transportation cost changed from: ' + curpricing.outskirttransportationcost + ' To ' + pricing.outskirttransportationcost);
            if (curpricing.maxccdiscount != pricing.maxccdiscount)
                updatedetails.push('Max discount changed from: ' + curpricing.maxccdiscount + ' To ' + pricing.maxccdiscount);
            if (updatedetails.length > 0) {
                var auditlog = {};
                auditlog.id = "" + this.dynamoLib.getTime();
                auditlog.mastername = 'businesscustomer';
                auditlog.entityrefid = pricing.id;
                auditlog.businessdate = this.util.getCurrentBusinessDate();
                auditlog.versionafter = pricing.objectversion;
                auditlog.versionbefore = curpricing.objectversion;
                auditlog.entityrefname = pricing.productname;
                auditlog.updatetype = 'edit';
                auditlog.updatedetails = updatedetails;
                if (!pricing.last10updates)
                    pricing.last10updates = [];
                pricing.last10updates.push(auditlog.id);
                return auditlog;
            }
        }
        return null;
    }
}
AuditService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AuditService, deps: [{ token: AppdataService }, { token: UtilService }, { token: i3.DynamoLibService }], target: i0.ɵɵFactoryTarget.Injectable });
AuditService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AuditService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AuditService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: AppdataService }, { type: UtilService }, { type: i3.DynamoLibService }]; } });

class DupcheckService {
    constructor(dataService) {
        this.dataService = dataService;
    }
    checkDuplicateState(state) {
        for (var st of this.dataService.statelist) {
            if (st.id != state.id && st.name.toLowerCase() == state.name.toLowerCase())
                return true;
        }
        return false;
    }
    checkDuplicateUsergroup(usergroup) {
        for (var st of this.dataService.usergrouplist) {
            if (st.id != usergroup.id && st.name.toLowerCase() == usergroup.name.toLowerCase())
                return true;
        }
        return false;
    }
    checkDuplicateUser(user) {
        for (var st of this.dataService.userlist) {
            if (st.id != user.id && st.name.toLowerCase() == user.name.toLowerCase())
                return true;
            if (st.id != user.id && st.username.toLowerCase() == user.username.toLowerCase())
                return true;
        }
        return false;
    }
    checkDuplicateCity(city) {
        for (var ct of this.dataService.citylist) {
            if (ct.id != city.id && ct.name.toLowerCase() == city.name.toLowerCase())
                return true;
        }
        return false;
    }
    checkDuplicateProductcitypricing(citypricing) {
        for (var ct of this.dataService.productcitypricinglist) {
            if (ct.id != citypricing.id && ct.productid == citypricing.productid && ct.cityid == citypricing.cityid)
                return true;
        }
        return false;
    }
    checkDuplicateB2bcustomerpricing(pricing) {
        for (var ct of this.dataService.b2bcustomerpricinglist) {
            if (ct.id != pricing.id && ct.productid == pricing.productid && ct.customerid == pricing.customerid && ct.cityid == pricing.cityid)
                return true;
        }
        return false;
    }
    checkDuplicateVendor(vendor) {
        for (var vndr of this.dataService.vendorlist) {
            if (vndr.id != vendor.id && vndr.businessname.toLowerCase() == vendor.businessname.toLowerCase())
                return true;
            if (vndr.id != vendor.id && vndr.gstinno.toLowerCase() == vendor.gstinno.toLowerCase())
                return true;
        }
        return false;
    }
    checkDuplicateProductspecification(productspecification) {
        for (var brnd of this.dataService.productspecificationlist) {
            if (brnd.id != productspecification.id && brnd.name.toLowerCase() == productspecification.name.toLowerCase())
                return true;
        }
        return false;
    }
    checkDuplicateProduct(product) {
        for (var prod of this.dataService.productlist) {
            if (prod.id != product.id && prod.name.toLowerCase() == product.name.toLowerCase() && prod.brandid == product.brandid && prod.modelno.trim().toLowerCase() == product.modelno.trim().toLowerCase())
                return true;
            if (prod.id != product.id && prod.code.toLowerCase() == product.code.toLowerCase())
                return true;
        }
        return false;
    }
    checkDuplicateBrand(brand) {
        for (var brnd of this.dataService.brandlist) {
            if (brnd.id != brand.id && brnd.name.toLowerCase() == brand.name.toLowerCase())
                return true;
        }
        return false;
    }
    checkDuplicateCustomer(cust) {
        return false;
    }
    checkDuplicateBusinessCustomer(customer) {
        for (var cust of this.dataService.businesscustomerlist) {
            if (cust.id != customer.id && cust.orgname.toLowerCase() == customer.orgname.toLowerCase())
                return true;
        }
        return false;
    }
    checkDuplicateProductcategory(category) {
        for (var cat of this.dataService.categorylist) {
            if (cat.id != category.id && cat.name.toLowerCase() == category.name.toLowerCase())
                return true;
        }
        return false;
    }
    checkDuplicateProductSubcategory(subcategory) {
        for (var subcat of this.dataService.subcategorylist) {
            if (subcat.id != subcategory.id && subcat.name.toLowerCase() == subcategory.name.toLowerCase())
                return true;
        }
        return false;
    }
    checkDuplicateAgent(agent) {
        for (var agnt of this.dataService.agentlist) {
            if (agnt.id != agent.id && agnt.agentname.toLowerCase() == agent.agentname.toLowerCase())
                return true;
            if (agnt.id != agent.id && agnt.panno.toLowerCase() == agent.panno.toLowerCase())
                return true;
        }
        return false;
    }
    checkDuplicateWarehouse(warehouse) {
        for (var warehse of this.dataService.warehouselist) {
            if (warehse.id != warehouse.id && warehse.name.toLowerCase() == warehouse.name.toLowerCase())
                return true;
        }
        return false;
    }
}
DupcheckService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DupcheckService, deps: [{ token: AppdataService }], target: i0.ɵɵFactoryTarget.Injectable });
DupcheckService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DupcheckService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DupcheckService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: AppdataService }]; } });

class ValidatorService {
    constructor(dataService, privService, dupcheckService) {
        this.dataService = dataService;
        this.privService = privService;
        this.dupcheckService = dupcheckService;
        this.statevalidator = [{ attrib: 'name', display: 'Name', required: true, numeric: false }];
    }
    validateAttributes(validators, object) {
        for (var validator of validators) {
            var value = object[validator.attrib];
            if (!value || value.trim().length == 0) {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: validator.display + ' can not be blank!' };
            }
        }
    }
    validateUsergroup(usergroup) {
        if (!usergroup.name || usergroup.name.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Usergroup name can not be blank!' };
        }
        if (!usergroup.privileges || usergroup.privileges.length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please assign at least one privilege!' };
        }
        if (this.dupcheckService.checkDuplicateUsergroup(usergroup)) {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Usergroup name already exists!' };
        }
        //check with dupchek service and update
        if (this.dupcheckService.checkDuplicateUsergroup(usergroup)) {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'User group name already exists!' };
        }
        //Trim the name
        usergroup.name = usergroup.name.trim();
        usergroup.privilegestring = this.privService.getPrivilegeString(usergroup);
        return { status: 'success' };
    }
    validateUser(user) {
        if (!user.name || user.name.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'User name can not be blank!' };
        }
        if (!user.mobileno || user.mobileno.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'User mobile number can not be blank!' };
        }
        if (!user.email || user.email.length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'User emailid can not be blank!' };
        }
        var usergroupidx = this.dataService.getIndexInMasterList(this.dataService.usergrouplist, user.usergroupid);
        if (usergroupidx == -1) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please choose a valid User group!' };
        }
        var group = this.dataService.usergrouplist[usergroupidx];
        user.usergroupname = group.name;
        user.privileges = group.privileges;
        //check with dupchek service and update
        if (this.dupcheckService.checkDuplicateUser(user)) {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Name/Username already exists!' };
        }
        //Trim the name
        user.name = user.name.trim();
        return { status: 'success' };
    }
    validateState(state) {
        if (!state.name || state.name.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'State name can not be blank!' };
        }
        if (this.dupcheckService.checkDuplicateState(state)) {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'State name already exists!' };
        }
        //Trim the name 
        state.name = state.name.trim();
        return { status: 'success' };
    }
    validateB2bcustomerpricing(pricing, nodupcheck) {
        if (!pricing.productid || pricing.productid.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Product name can not be blank!' };
        }
        if (!pricing.customerid || pricing.customerid.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Customer name can not be blank!' };
        }
        var productidx = this.dataService.getIndexInMasterList(this.dataService.productlist, pricing.productid);
        if (productidx == -1) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please choose valid product!' };
        }
        var prd = this.dataService.productlist[productidx];
        pricing.productname = prd.name;
        var custidx = this.dataService.getIndexInMasterList(this.dataService.businesscustomerlist, pricing.customerid);
        if (custidx == -1) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please choose valid customer!' };
        }
        var cust = this.dataService.businesscustomerlist[custidx];
        pricing.customername = cust.orgname;
        var cityidx = this.dataService.getIndexInMasterList(this.dataService.citylist, pricing.cityid);
        if (custidx == -1) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please choose valid city!' };
        }
        var city = this.dataService.citylist[cityidx];
        pricing.cityname = city.name;
        if (!pricing.dailyrent || isNaN(pricing.dailyrent)) {
            pricing.dailyrent = 0;
            //return {status : 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid daily rent!',errorsection: 'productpricing'};
        }
        if (!pricing.weeklyrent || isNaN(pricing.weeklyrent)) {
            pricing.weeklyrent = 0;
            //return {status : 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid weekly rent!',errorsection: 'productpricing'};
        }
        if (!pricing.monthlyrent || isNaN(pricing.monthlyrent)) {
            pricing.monthlyrent = 0;
            //return {status : 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid monthly rent!',errorsection: 'productpricing'};
        }
        if (!pricing.sellingrate || isNaN(pricing.sellingrate)) {
            pricing.sellingrate = 0;
            //return {status : 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid selling price!',errorsection: 'productpricing'};
        }
        if (!pricing.depositforrent || isNaN(pricing.depositforrent)) {
            pricing.depositforrent = 0;
            //return {status : 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid deposit for rent !',errorsection: 'productpricing'};
        }
        if (!pricing.transportationcost || isNaN(pricing.transportationcost)) {
            pricing.transportationcost = 0;
            //return {status : 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid transportation cost!',errorsection: 'productpricing'};
        }
        if (!pricing.outskirttransportationcost || isNaN(pricing.outskirttransportationcost)) {
            pricing.outskirttransportationcost = 0;
            //return {status : 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid outskirts transportation cost!',errorsection: 'productpricing'};
        }
        if (!pricing.maxccdiscount || isNaN(pricing.maxccdiscount)) {
            pricing.maxccdiscount = 0;
            //return {status : 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid maximum callcenter discount!',errorsection: 'productpricing'};
        }
        if (!nodupcheck) {
            if (this.dupcheckService.checkDuplicateB2bcustomerpricing(pricing)) {
                return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Pricing for this product and customer already exists!' };
            }
        }
        //Trim the name 
        return { status: 'success' };
    }
    validateProductcitypricing(pricing) {
        if (!pricing.productid || pricing.productid.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Product name can not be blank!' };
        }
        if (!pricing.cityid || pricing.cityid.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'City name can not be blank!' };
        }
        if (!pricing.pricingtype || pricing.pricingtype.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please choose a pricing type!' };
        }
        var productidx = this.dataService.getIndexInMasterList(this.dataService.productlist, pricing.productid);
        if (productidx == -1) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please choose valid product!' };
        }
        var prd = this.dataService.productlist[productidx];
        pricing.productname = prd.name;
        if (pricing.pricingtype == 'relative') {
            //return {status : 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please choose a pricing type!'};
            if (!pricing.escalationvaluerent || isNaN(parseInt("" + pricing.escalationvaluerent))) {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please choose valid escalation value for rent!' };
            }
            if (!pricing.escalationvaluesale || isNaN(parseInt("" + pricing.escalationvaluesale))) {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please choose valid escalation value for sale!' };
            }
            pricing.citypricing = null;
        }
        else {
            pricing.escalationvaluerent = 0;
            pricing.escalationvaluesale = 0;
            var ret = this.validateProductPricing(pricing.citypricing, prd);
            if (ret.status != 'success') {
                return ret;
            }
        }
        if (this.dupcheckService.checkDuplicateProductcitypricing(pricing)) {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Pricing for this product and city already exists!' };
        }
        var cityidx = this.dataService.getIndexInMasterList(this.dataService.citylist, pricing.cityid);
        if (cityidx == -1) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please choose valid city!' };
        }
        var city = this.dataService.citylist[cityidx];
        pricing.cityname = city.name;
        //Trim the name 
        return { status: 'success' };
    }
    validateCity(city) {
        if (!city.name || city.name.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'City name can not be blank!' };
        }
        if (this.dupcheckService.checkDuplicateCity(city)) {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'City name already exists!' };
        }
        var stateidx = this.dataService.getIndexInMasterList(this.dataService.statelist, city.stateid);
        if (stateidx == -1) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please choose valid state!' };
        }
        if (city.billingcityid && city.billingcityid.length > 0) {
            if (city.billingcityid == city.id) {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please provide billing city only when it is different!' };
            }
            var cityidx = this.dataService.getIndexInMasterList(this.dataService.citylist, city.billingcityid);
            if (cityidx > -1) {
                var blngcity = this.dataService.citylist[cityidx];
                city.billingcityname = blngcity.name;
            }
        }
        var state = this.dataService.statelist[stateidx];
        city.statename = state.name;
        //Trim the name 
        city.name = city.name.trim();
        return { status: 'success' };
    }
    validateProductsubcategory(productsubcategory) {
        if (!productsubcategory.name || productsubcategory.name.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Product subcategory name can not be blank!' };
        }
        if (!productsubcategory.code || productsubcategory.code.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Product subcategory code can not be blank!' };
        }
        if (!productsubcategory.sortorder || productsubcategory.sortorder < 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid sort order!' };
        }
        if (this.dupcheckService.checkDuplicateProductSubcategory(productsubcategory)) {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Subcategory name already exists!' };
        }
        var categoryidx = this.dataService.getIndexInMasterList(this.dataService.categorylist, productsubcategory.categoryid);
        if (categoryidx == -1) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please choose valid category!' };
        }
        var category = this.dataService.categorylist[categoryidx];
        //Trim the name 
        productsubcategory.name = productsubcategory.name.trim();
        productsubcategory.category = category;
        return { status: 'success' };
    }
    validateProductcategory(productcategory) {
        if (!productcategory.name || productcategory.name.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Product category name can not be blank!' };
        }
        if (!productcategory.code || productcategory.code.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Product category code can not be blank!' };
        }
        if (!productcategory.sortorder || productcategory.sortorder < 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid sort order!' };
        }
        if (this.dupcheckService.checkDuplicateProductcategory(productcategory)) {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Category name already exists!' };
        }
        //Trim the name 
        productcategory.name = productcategory.name.trim();
        return { status: 'success' };
    }
    validateBrand(brand) {
        if (!brand.name || brand.name.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Brand name can not be blank!' };
        }
        if (this.dupcheckService.checkDuplicateBrand(brand)) {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Brand name already exists!' };
        }
        //Trim the name 
        brand.name = brand.name.trim();
        return { status: 'success' };
    }
    validateProductspecification(productspecification) {
        if (!productspecification.name || productspecification.name.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Productspecification name can not be blank!' };
        }
        if (this.dupcheckService.checkDuplicateProductspecification(productspecification)) {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Productspecification name already exists!' };
        }
        //Trim the name 
        productspecification.name = productspecification.name.trim();
        return { status: 'success' };
    }
    validateAgent(agent) {
        if (!agent.agentname || agent.agentname.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Agent name can not be blank!', errorsection: 'info' };
        }
        if (!agent.panno || agent.panno.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Agent PAN can not be blank!', errorsection: 'info' };
        }
        if (this.dupcheckService.checkDuplicateAgent(agent)) {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Agent name/PAN No already exists!', errorsection: 'info' };
        }
        var cityidx = this.dataService.getIndexInMasterList(this.dataService.citylist, agent.cityid);
        if (cityidx == -1) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please choose valid city!', errorsection: 'address' };
        }
        var city = this.dataService.citylist[cityidx];
        agent.cityname = city.name;
        agent.stateid = city.stateid;
        agent.statename = city.statename;
        if (!agent.agentaddress) {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Please provide agent address!', errorsection: 'address' };
        }
        var retaddr = this.validateAddress(agent.agentaddress, 'address');
        if (retaddr.status != 'success') {
            return retaddr;
        }
        if (!agent.accountinfo) {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Please provide account information!', errorsection: 'accountinfo' };
        }
        var ret = this.validateAccountinfo(agent.accountinfo, 'accountinfo');
        if (ret.status != 'success') {
            return ret;
        }
        //Trim the name 
        agent.agentname = agent.agentname.trim();
        return { status: 'success' };
    }
    validateWarehouse(warehouse) {
        if (!warehouse.name || warehouse.name.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Warehouse name can not be blank!', errorsection: 'warehouseinfo' };
        }
        if (this.dupcheckService.checkDuplicateWarehouse(warehouse)) {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Warehouse name already exists!', errorsection: 'warehouseinfo' };
        }
        var cityidx = this.dataService.getIndexInMasterList(this.dataService.citylist, warehouse.cityid);
        if (cityidx == -1) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please choose valid city!', errorsection: 'warehouseinfo' };
        }
        var city = this.dataService.citylist[cityidx];
        warehouse.cityname = city.name;
        warehouse.stateid = city.stateid;
        warehouse.statename = city.statename;
        if (!warehouse.address) {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Please provide warehouse address!', errorsection: 'address' };
        }
        var retaddr = this.validateAddress(warehouse.address, 'address');
        if (retaddr.status != 'success') {
            return retaddr;
        }
        //Trim the name 
        warehouse.name = warehouse.name.trim();
        return { status: 'success' };
    }
    validateCustomer(cust) {
        return { status: 'success' };
    }
    validateBusinesscustomer(cust) {
        if (!cust.orgname || cust.orgname.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Organization name can not be blank!', errorsection: 'info' };
        }
        if (!cust.email || cust.email.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Email address can not be blank!', errorsection: 'info' };
        }
        if (!cust.whatasappnummber || cust.whatasappnummber.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Whatsapp alert no can not be blank!', errorsection: 'info' };
        }
        if (!cust.gstinno || cust.gstinno.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'GSTIN No can not be blank!', errorsection: 'info' };
        }
        if (this.dupcheckService.checkDuplicateBusinessCustomer(cust)) {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Organization name already exists!', errorsection: 'info' };
        }
        if (!cust.address) {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Please provide registered address!', errorsection: 'address' };
        }
        var retaddr = this.validateAddress(cust.address, 'customeraddress');
        if (retaddr.status != 'success') {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Error in customer address: ' + retaddr.errordescription, errorsection: 'address' };
        }
        if (!cust.accountinfo) {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Please provide account information!', errorsection: 'accountinfo' };
        }
        var ret = this.validateAccountinfo(cust.accountinfo, 'accountinfo');
        if (ret.status != 'success') {
            return ret;
        }
        return { status: 'success' };
    }
    validateProduct(prod) {
        if (!prod.name || prod.name.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Product name can not be blank!', errorsection: 'info' };
        }
        if (!prod.code || prod.code.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Product code can not be blank!', errorsection: 'info' };
        }
        var brandidx = this.dataService.getIndexInMasterList(this.dataService.brandlist, prod.brandid);
        if (brandidx == -1) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please choose valid brand!', errorsection: 'info' };
        }
        var brand = this.dataService.brandlist[brandidx];
        prod.brandname = brand.name;
        if (!prod.modelno || prod.modelno.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Product model no can not be blank!', errorsection: 'info' };
        }
        if (!prod.introductionline || prod.introductionline.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Introduction line  can not be blank!', errorsection: 'info' };
        }
        if (!prod.description || prod.description.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Description  can not be blank!', errorsection: 'info' };
        }
        var categoryidx = this.dataService.getIndexInMasterList(this.dataService.categorylist, prod.categoryid);
        if (categoryidx == -1) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please choose valid category!', errorsection: 'info' };
        }
        var cat = this.dataService.categorylist[categoryidx];
        prod.categoryname = cat.name;
        var subcategoryidx = this.dataService.getIndexInMasterList(this.dataService.subcategorylist, prod.subcategoryid);
        if (subcategoryidx == -1) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please choose valid subcategory!', errorsection: 'info' };
        }
        var subcat = this.dataService.subcategorylist[subcategoryidx];
        prod.subcategory = subcat;
        var ret = this.validateProductPricing(prod.productpricing, prod);
        if (ret.status != 'success') {
            return ret;
        }
        if (prod.billingtype == 'SALE' || prod.billingtype == 'BOTH') {
            if (!prod.gstpercentage || isNaN(prod.gstpercentage) || prod.gstpercentage < 0) {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please provide valid GST Percentage!', errorsection: 'productpricing' };
            }
        }
        if (prod.billingtype == 'RENT' || prod.billingtype == 'BOTH') {
            if (!prod.gstpercentagerent || isNaN(prod.gstpercentagerent) || prod.gstpercentagerent < 0) {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please provide valid GST Percentage For Rent!', errorsection: 'productpricing' };
            }
        }
        if (!prod.imagefiles || prod.imagefiles.length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Please provide at least one image!', errorsection: 'images' };
        }
        if (this.dupcheckService.checkDuplicateProduct(prod)) {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Product name/code already exists!', errorsection: 'info' };
        }
        return { status: 'success' };
    }
    validateVendor(vendor) {
        if (!vendor.businessname || vendor.businessname.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Business name can not be blank!', errorsection: 'info' };
        }
        if (!vendor.gstinno || vendor.gstinno.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'GSTIN No can not be blank!', errorsection: 'info' };
        }
        if (!vendor.whatasappnummber || vendor.whatasappnummber.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'WhatsApp No can not be blank!', errorsection: 'info' };
        }
        if (!vendor.contactnumbers || vendor.contactnumbers.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Contact no(s) can not be blank!', errorsection: 'info' };
        }
        if (!vendor.contactperson || vendor.contactperson.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Contact person can not be blank!', errorsection: 'info' };
        }
        if (this.dupcheckService.checkDuplicateVendor(vendor)) {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Vendor business name/GSTIN No already exists!', errorsection: 'info' };
        }
        if (!vendor.registeredaddress) {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Please provide registered address of the vendor!', errorsection: 'address' };
        }
        var retaddr = this.validateAddress(vendor.registeredaddress, 'address');
        if (retaddr.status != 'success') {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Error in registered address: ' + retaddr.errordescription, errorsection: 'address' };
        }
        if (!vendor.warehouseaddresses || vendor.warehouseaddresses.length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Please provide at least one warehouse address!', errorsection: 'warehouseaddress' };
        }
        for (var i = 0; i < vendor.warehouseaddresses.length; i++) {
            var addr = vendor.warehouseaddresses[i];
            var retaddr = this.validateAddress(addr);
            if (retaddr.status != 'success') {
                var addrno = i + 1;
                return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Error in warehouse address #' + addrno + ': ' + retaddr.errordescription, errorsection: 'warehouseaddress' };
            }
        }
        if (!vendor.accountinfo) {
            return { status: 'error', statuserrorcode: Constants.DML_DUPLICATE, errordescription: 'Please provide account information!', errorsection: 'accountinfo' };
        }
        var ret = this.validateAccountinfo(vendor.accountinfo, 'accountinfo');
        if (ret.status != 'success') {
            return ret;
        }
        var ret = this.validateVendorDocs(vendor);
        if (ret.status != 'success') {
            return ret;
        }
        //Trim the name 
        return { status: 'success' };
    }
    checkVendorDoc(vendor, docname) {
        for (var file of vendor.vendorfiles) {
            if (file.documentname == docname)
                return true;
        }
        return false;
    }
    validateVendorDocs(vendor) {
        //return true; 
        /*if(!this.checkVendorDoc(vendor, 'pancard')) {
            return {status : 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please upload PAN card!',errorsection: 'documents'};
        }
        if(!this.checkVendorDoc(vendor, 'vendoraggreement')) {
            return {status : 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please upload vendor aggreement!',errorsection: 'documents'};
        }
        if(vendor.companytype != 'Individual'){
            if(!this.checkVendorDoc(vendor, 'gstcertificate')) {
                return {status : 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please upload GST Certificate!',errorsection: 'documents'};
            }
            if(!this.checkVendorDoc(vendor, 'shopestcertificate')) {
                return {status : 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please upload Shop Establishment Certificate!',errorsection: 'documents'};
            }
        }*/
        return { status: 'success' };
    }
    validateAddress(address, errorsection) {
        if (!address.addressline1 || address.addressline1.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Address Line 1 can not be blank!', errorsection: errorsection };
        }
        var cityidx = this.dataService.getIndexInMasterList(this.dataService.citylist, address.cityid);
        if (cityidx == -1) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please select valid city!', errorsection: errorsection };
        }
        var city = this.dataService.citylist[cityidx];
        address.cityname = city.name;
        address.statename = city.statename;
        address.stateid = city.stateid;
        if (!address.pincode || address.pincode.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'PIN Code can not be blank!', errorsection: errorsection };
        }
        if (!address.landmark || address.landmark.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Landmark can not be blank!', errorsection: errorsection };
        }
        if (!address.tag || address.tag.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please provide a Tag to the address!', errorsection: errorsection };
        }
        address.addressline1 = address.addressline1.trim();
        if (address.addressline2)
            address.addressline2 = address.addressline2.trim();
        address.pincode = address.pincode.trim();
        address.landmark = address.landmark.trim();
        address.tag = address.tag.trim();
        return { status: 'success' };
    }
    validateAccountinfo(accountinfo, errorsection) {
        if (!accountinfo.accountname || accountinfo.accountname.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Beneficiary account Name can not be blank in Account information!', errorsection: errorsection };
        }
        if (!accountinfo.accountnumber || accountinfo.accountnumber.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Account Number can not be blank in Account information!', errorsection: errorsection };
        }
        if (!accountinfo.bankname || accountinfo.bankname.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Bank name can not be blank in Account information!', errorsection: errorsection };
        }
        if (!accountinfo.branchname || accountinfo.branchname.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Branch name can not be blank in Account information!', errorsection: errorsection };
        }
        if (!accountinfo.ifsccode || accountinfo.ifsccode.trim().length == 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'IFSC Code  can not be blank in Account information!', errorsection: errorsection };
        }
        accountinfo.accountname = accountinfo.accountname.trim();
        accountinfo.bankname = accountinfo.bankname.trim();
        accountinfo.accountnumber = accountinfo.accountnumber.trim();
        accountinfo.branchname = accountinfo.branchname.trim();
        accountinfo.ifsccode = accountinfo.ifsccode.trim();
        return { status: 'success' };
    }
    validateProductPricing(pricing, prod) {
        if (prod.billingtype == 'SALE' || prod.billingtype == 'BOTH') {
            if (!pricing.retailsellingrate || isNaN(pricing.retailsellingrate) || pricing.retailsellingrate <= 0) {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid retail selling price!', errorsection: 'productpricing' };
            }
            if (!pricing.bulksellingrate || isNaN(pricing.bulksellingrate) || pricing.bulksellingrate <= 0) {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid bulk selling price!', errorsection: 'productpricing' };
            }
            if (!pricing.partnersellingrate || isNaN(pricing.partnersellingrate) || pricing.partnersellingrate <= 0) {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid partner selling price!', errorsection: 'productpricing' };
            }
        }
        if (prod.billingtype == 'RENT' || prod.billingtype == 'BOTH') {
            if (!pricing.retailmonthlyrent || isNaN(pricing.retailmonthlyrent) || pricing.retailmonthlyrent <= 0) {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid retail monthly rent!', errorsection: 'productpricing' };
            }
            if (!pricing.bulkmonthlyrent || isNaN(pricing.bulkmonthlyrent) || pricing.bulkmonthlyrent <= 0) {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid bulk monthly rent!', errorsection: 'productpricing' };
            }
            if (!pricing.partnermonthlyrent || isNaN(pricing.partnermonthlyrent) || pricing.partnermonthlyrent <= 0) {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid partner monthly rent!', errorsection: 'productpricing' };
            }
            if (pricing.weeklypriceapplicable) {
                if (!pricing.retailweeklyrent || isNaN(pricing.retailweeklyrent) || pricing.retailweeklyrent <= 0) {
                    return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid retail weekly rent!', errorsection: 'productpricing' };
                }
                if (!pricing.bulkweeklyrent || isNaN(pricing.bulkweeklyrent) || pricing.bulkweeklyrent <= 0) {
                    return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid bulk weekly rent!', errorsection: 'productpricing' };
                }
                if (!pricing.partnerweeklyrent || isNaN(pricing.partnerweeklyrent) || pricing.partnerweeklyrent <= 0) {
                    return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid partner weekly rent!', errorsection: 'productpricing' };
                }
            }
            if (pricing.depositforrent == null || isNaN(pricing.depositforrent)) {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid deposit for rent!', errorsection: 'productpricing' };
            }
        }
        if (pricing.transportationcost == null || pricing.transportationcost < 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please provide transportation cost!', errorsection: 'productpricing' };
        }
        if (pricing.retaildiscountbuy == null || pricing.retaildiscountbuy < 0) {
            pricing.retaildiscountbuy = 0;
        }
        if (pricing.retaildiscountrent == null || pricing.retaildiscountrent < 0) {
            pricing.retaildiscountrent = 0;
        }
        if (pricing.outskirttransportationcost == null || pricing.outskirttransportationcost < 0) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please provide outskirt transportation cost!', errorsection: 'productpricing' };
        }
        return { status: 'success' };
    }
    validateVendorPricing(pricing) {
        if (pricing.availabilitytype == 'SALE' || pricing.availabilitytype == 'BOTH') {
            if (!pricing.sellingprice || isNaN(pricing.sellingprice) || pricing.sellingprice <= 0) {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid selling price!', errorsection: 'productpricing' };
            }
        }
        if (pricing.availabilitytype == 'RENT' || pricing.availabilitytype == 'BOTH') {
            if (!pricing.monthlyrent || isNaN(pricing.monthlyrent) || pricing.monthlyrent <= 0) {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid monthly rent!', errorsection: 'productpricing' };
            }
            if (pricing.weeklypriceapplicable) {
                if (!pricing.weeklyrent || isNaN(pricing.weeklyrent) || pricing.weeklyrent <= 0) {
                    return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid weekly rent!', errorsection: 'productpricing' };
                }
            }
            if (!pricing.depositforrent || isNaN(pricing.depositforrent) || pricing.depositforrent < 0) {
                pricing.depositforrent = 0;
            }
        }
        return { status: 'success' };
    }
}
ValidatorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ValidatorService, deps: [{ token: AppdataService }, { token: PrivilegeService }, { token: DupcheckService }], target: i0.ɵɵFactoryTarget.Injectable });
ValidatorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ValidatorService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ValidatorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: AppdataService }, { type: PrivilegeService }, { type: DupcheckService }]; } });

class ExcelimportService {
    constructor(auditService, validatorService, dynamoLib, util, dataService) {
        this.auditService = auditService;
        this.validatorService = validatorService;
        this.dynamoLib = dynamoLib;
        this.util = util;
        this.dataService = dataService;
    }
    extractAndValidtePricingFromExcel(excelrecord, retentity, rownum) {
        var strproductid, strcustomerid, strcityid, dailyrent, weeklyrent, monthlyrent, sellingrate, depositforrent, transportationcost, outskirttransportationcost, maxccdiscount;
        if (!excelrecord["A"])
            strcustomerid = "";
        else
            strcustomerid = "" + excelrecord["A"];
        retentity.customerid = strcustomerid;
        if (!excelrecord["B"])
            strproductid = "";
        else
            strproductid = "" + excelrecord["B"];
        retentity.productid = strproductid;
        if (!excelrecord["C"])
            strcityid = "";
        else
            strcityid = "" + excelrecord["C"];
        retentity.cityid = strcityid;
        if (!excelrecord["D"])
            dailyrent = "";
        else
            dailyrent = "" + excelrecord["D"];
        retentity.dailyrent = parseInt(dailyrent);
        if (!excelrecord["E"])
            weeklyrent = "";
        else
            weeklyrent = "" + excelrecord["E"];
        retentity.weeklyrent = parseInt(weeklyrent);
        if (!excelrecord["F"])
            monthlyrent = "";
        else
            monthlyrent = "" + excelrecord["F"];
        retentity.monthlyrent = parseInt(monthlyrent);
        if (!excelrecord["G"])
            sellingrate = "";
        else
            sellingrate = "" + excelrecord["G"];
        retentity.sellingrate = parseInt(sellingrate);
        if (!excelrecord["H"])
            depositforrent = "";
        else
            depositforrent = "" + excelrecord["H"];
        retentity.depositforrent = parseInt(depositforrent);
        if (!excelrecord["I"])
            transportationcost = "";
        else
            transportationcost = "" + excelrecord["I"];
        retentity.transportationcost = parseInt(transportationcost);
        if (!excelrecord["J"])
            outskirttransportationcost = "";
        else
            outskirttransportationcost = "" + excelrecord["J"];
        retentity.outskirttransportationcost = parseInt(outskirttransportationcost);
        if (!excelrecord["K"])
            maxccdiscount = "";
        else
            maxccdiscount = "" + excelrecord["K"];
        retentity.maxccdiscount = parseInt(maxccdiscount);
        var retresponse = this.validatorService.validateB2bcustomerpricing(retentity, true);
        if (retresponse.status != 'success') {
            retresponse.errordescription = 'Error at row number: ' + rownum + ': ' + retresponse.errordescription;
        }
        return retresponse;
    }
    getExistingB2bcustomerpricing(pricing) {
        for (var curpricing of this.dataService.b2bcustomerpricinglist) {
            if (curpricing.customerid == pricing.customerid && curpricing.productid == pricing.productid && curpricing.cityid == pricing.cityid) {
                console.log('CHECKING RETURNING TRUE ');
                return curpricing;
            }
        }
        return null;
    }
    setFieldsForCurrentEntity(entity, curentity) {
        entity['id'] = curentity['id'];
        entity['objectversion'] = curentity['objectversion'];
        entity['createdat'] = curentity['createdat'];
        entity['updatedat'] = curentity['updatedat'];
        entity['createdby'] = curentity['createdby'];
        entity['updatedby'] = curentity['updatedby'];
        entity['last10updates'] = curentity['last10updates'];
    }
    parseB2bpricingExcel(excelrecords) {
        //var metadata = this.metadataService.getEntityDefinition(entitytype);
        var arrret = [];
        for (var i = 1; i < excelrecords.length; i++) {
            var excelrec = excelrecords[i];
            var entity = {};
            var ret = this.extractAndValidtePricingFromExcel(excelrec, entity, i);
            if (ret.status != 'success')
                return ret;
            entity['uploadtype'] = 'create';
            var curentity = this.getExistingB2bcustomerpricing(entity);
            if (curentity) {
                this.setFieldsForCurrentEntity(entity, curentity);
                entity['uploadtype'] = 'edit';
            }
            arrret.push(entity);
        }
        return { status: 'success', returnrecords: arrret };
    }
    importB2bpricingRecords(records) {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "importExcelRecords++");
            //var metadata = this.metadataService.getEntityDefinition(entitytype);
            this.numimported = 0;
            for (var rec of records) {
                var resp = this.validatorService.validateB2bcustomerpricing(rec);
                if (resp.status == 'success') {
                    var txnitems = [];
                    if (rec['uploadtype'] == 'create') {
                        rec.id = "" + this.dynamoLib.getTime();
                        var txnitem = this.util.getTransactionItem('create', this.util.getTableName('b2bcustomerpricing'), rec, "attribute_not_exists(id)");
                        txnitems.push(txnitem);
                    }
                    else {
                        var txnitem = this.util.getTransactionItem('edit', this.util.getTableName('b2bcustomerpricing'), rec);
                        txnitems.push(txnitem);
                        var auditItem = this.auditService.getB2bcustomerpricingAuditTrail(rec);
                        if (auditItem) {
                            var txnaudititem = this.util.getAuditTransactionItem(this.util.getTableName('setupaudittrail'), auditItem);
                            txnitems.push(txnaudititem);
                        }
                    }
                    var ret = yield this.dynamoLib.performTransaction(txnitems);
                    if (!ret)
                        rec['uploadstatus'] = 'Upload failed';
                    else {
                        this.dataService.updateMasterList('b2bcustomerpricing', rec['uploadtype'], rec);
                        rec['uploadstatus'] = 'success';
                    }
                }
                else
                    rec['uploadstatus'] = 'Validation failed';
                this.numimported = this.numimported + 1;
            }
            this.util.log(Constants.LOG_DEBUG, "importExcelRecords--");
            return records;
        });
    }
}
ExcelimportService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ExcelimportService, deps: [{ token: AuditService }, { token: ValidatorService }, { token: i3.DynamoLibService }, { token: UtilService }, { token: AppdataService }], target: i0.ɵɵFactoryTarget.Injectable });
ExcelimportService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ExcelimportService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ExcelimportService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: AuditService }, { type: ValidatorService }, { type: i3.DynamoLibService }, { type: UtilService }, { type: AppdataService }]; } });

class VendorService {
    constructor(validatorService, dynamoLib, auditService, dataService, util, dblib) {
        this.validatorService = validatorService;
        this.dynamoLib = dynamoLib;
        this.auditService = auditService;
        this.dataService = dataService;
        this.util = util;
        this.dblib = dblib;
    }
    updateVendorPriceInList(vendorpricing) {
        if (this.dataService.vendorpricinglist && this.dataService.vendorpricinglist.length > 0) {
            for (var i = 0; i < this.dataService.vendorpricinglist.length; i++) {
                var curprice = this.dataService.vendorpricinglist[i];
                if (curprice.productid == vendorpricing.productid) {
                    this.dataService.vendorpricinglist[i] = vendorpricing;
                    this.dataService.vendorpricinglist = [...this.dataService.vendorpricinglist];
                }
            }
        }
    }
    rejectVendorPricing(vendorpricing, rejectreason) {
        return __awaiter(this, void 0, void 0, function* () {
            var cloneVendorpricing = cloneDeep(vendorpricing);
            cloneVendorpricing.availabilitystatus = 'Price Rejected';
            cloneVendorpricing.isenabled = false;
            cloneVendorpricing.rejectreason = rejectreason;
            var txnitems = [];
            var txnitem = this.util.getTransactionItem('edit', this.util.getTableName('vendorpricing'), cloneVendorpricing);
            txnitems.push(txnitem);
            var auditItem = yield this.auditService.getVendorPriceAuditTrail(cloneVendorpricing);
            if (auditItem) {
                var txnaudititem = this.util.getAuditTransactionItem(this.util.getTableName('vendorpriceaudit'), auditItem);
                txnitems.push(txnaudititem);
            }
            var ret = yield this.dynamoLib.performTransaction(txnitems);
            if (!ret)
                return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
            else {
                this.updateVendorPriceInList(cloneVendorpricing);
            }
            this.util.log(Constants.LOG_DEBUG, "rejectVendorPricing--");
            return { status: 'success' };
        });
    }
    enableVendorProduct(vendorpricing) {
        return __awaiter(this, void 0, void 0, function* () {
            var cloneVendorpricing = cloneDeep(vendorpricing);
            cloneVendorpricing.availabilitystatus = 'Available';
            cloneVendorpricing.isenabled = true;
            var txnitems = [];
            var txnitem = this.util.getTransactionItem('edit', this.util.getTableName('vendorpricing'), cloneVendorpricing);
            txnitems.push(txnitem);
            var auditItem = yield this.auditService.getVendorPriceAuditTrail(cloneVendorpricing);
            if (auditItem) {
                var txnaudititem = this.util.getAuditTransactionItem(this.util.getTableName('vendorpriceaudit'), auditItem);
                txnitems.push(txnaudititem);
            }
            var ret = yield this.dynamoLib.performTransaction(txnitems);
            if (!ret)
                return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
            else {
                this.updateVendorPriceInList(cloneVendorpricing);
            }
            this.util.log(Constants.LOG_DEBUG, "enableVendorProduct--");
            return { status: 'success' };
        });
    }
    disableVendorProduct(vendorpricing) {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "disableVendorProduct++");
            var cloneVendorpricing = cloneDeep(vendorpricing);
            cloneVendorpricing.availabilitystatus = 'Disabled';
            cloneVendorpricing.isenabled = false;
            var txnitems = [];
            var txnitem = this.util.getTransactionItem('edit', this.util.getTableName('vendorpricing'), cloneVendorpricing);
            txnitems.push(txnitem);
            var auditItem = yield this.auditService.getVendorPriceAuditTrail(cloneVendorpricing);
            if (auditItem) {
                var txnaudititem = this.util.getAuditTransactionItem(this.util.getTableName('vendorpriceaudit'), auditItem);
                txnitems.push(txnaudititem);
            }
            var ret = yield this.dynamoLib.performTransaction(txnitems);
            if (!ret)
                return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
            else {
                this.updateVendorPriceInList(cloneVendorpricing);
            }
            this.util.log(Constants.LOG_DEBUG, "disableVendorProduct--");
            return { status: 'success' };
        });
    }
    setVendorpricing(vendorpricing) {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "saveVendorpricing++");
            var cloneVendorpricing = cloneDeep(vendorpricing);
            cloneVendorpricing.availabilitystatus = 'Under Review';
            cloneVendorpricing.isenabled = false;
            var resp = this.validatorService.validateVendorPricing(cloneVendorpricing);
            if (resp.status == 'success') {
                var txnitems = [];
                var curprice = this.dataService.checkVendorPricing(cloneVendorpricing.productid);
                if (!curprice || curprice.availabilitystatus == 'Not mapped') {
                    var txnitem = this.util.getTransactionItem('create', this.util.getTableName('vendorpricing'), cloneVendorpricing, "attribute_not_exists(productid)");
                    txnitems.push(txnitem);
                }
                else {
                    var txnitem = this.util.getTransactionItem('edit', this.util.getTableName('vendorpricing'), cloneVendorpricing);
                    txnitems.push(txnitem);
                    var auditItem = yield this.auditService.getVendorPriceAuditTrail(cloneVendorpricing);
                    if (auditItem) {
                        var txnaudititem = this.util.getAuditTransactionItem(this.util.getTableName('vendorpriceaudit'), auditItem);
                        txnitems.push(txnaudititem);
                    }
                }
                var ret = yield this.dynamoLib.performTransaction(txnitems);
                if (!ret)
                    return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
                else {
                    this.updateVendorPriceInList(cloneVendorpricing);
                }
            }
            else
                return resp;
            this.util.log(Constants.LOG_DEBUG, "saveVendorpricing--");
            return { status: 'success' };
        });
    }
}
VendorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: VendorService, deps: [{ token: ValidatorService }, { token: i3.DynamoLibService }, { token: AuditService }, { token: AppdataService }, { token: UtilService }, { token: i3.DynamoLibService }], target: i0.ɵɵFactoryTarget.Injectable });
VendorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: VendorService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: VendorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ValidatorService }, { type: i3.DynamoLibService }, { type: AuditService }, { type: AppdataService }, { type: UtilService }, { type: i3.DynamoLibService }]; } });

class ArchivecheckService {
    constructor(dataService) {
        this.dataService = dataService;
    }
    validateStateDelete(state) {
        for (var city of this.dataService.citylist) {
            if (city.stateid == state.id)
                return false;
        }
        return true;
    }
    validateUserDelete(user) {
        return true;
    }
    validateB2bcustomerpricingdelete(pricing) {
        return true;
    }
    validateUsergroupDelete(usergroup) {
        for (var user of this.dataService.userlist) {
            if (user.usergroupid == usergroup.id)
                return false;
        }
        return true;
    }
    validateCityDelete(city) {
        for (var cust of this.dataService.businesscustomerlist) {
            if (cust.address && cust.address.cityid == city.id)
                return false;
        }
        for (var vendor of this.dataService.vendorlist) {
            if (vendor.registeredaddress.cityid == city.id)
                return false;
        }
        for (var warehouse of this.dataService.warehouselist) {
            if (warehouse.address.cityid == city.id)
                return false;
        }
        return true;
    }
    validateProdCategoryDelete(category) {
        for (var subcat of this.dataService.subcategorylist) {
            if (subcat.categoryid == category.id)
                return false;
        }
        return true;
    }
    validateProductcitypricingDelete(pricing) {
        return true;
    }
    validateProdSubCategoryDelete(subcategory) {
        for (var prod of this.dataService.productlist) {
            if (prod.subcategoryid == subcategory.id)
                return false;
        }
        return true;
    }
    validateBrandDelete(brand) {
        for (var prod of this.dataService.productlist) {
            if (prod.brandid == brand.id)
                return false;
        }
        return true;
    }
    validateProductspecificationDelete(prodspec) {
        return true;
    }
}
ArchivecheckService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ArchivecheckService, deps: [{ token: AppdataService }], target: i0.ɵɵFactoryTarget.Injectable });
ArchivecheckService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ArchivecheckService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ArchivecheckService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: AppdataService }]; } });

class SetupService {
    constructor(validatorService, archiveCheckService, auditService, dataService, util, dynamoLib) {
        this.validatorService = validatorService;
        this.archiveCheckService = archiveCheckService;
        this.auditService = auditService;
        this.dataService = dataService;
        this.util = util;
        this.dynamoLib = dynamoLib;
    }
    deleteStates(statelist) {
        return __awaiter(this, void 0, void 0, function* () {
            var txnitems = [];
            for (var state of statelist) {
                if (!this.archiveCheckService.validateStateDelete(state)) {
                    return { status: 'error', statuserrorcode: Constants.DML_PARENT_CHECK_FAILED, errordescription: 'State ' + state.name + ' Can not be deleted. Cities exist for the same!' };
                }
            }
            for (var state of statelist) {
                var cloneState = cloneDeep(state);
                var txnitem = this.util.getTransactionItem('delete', this.util.getTableName('state'), cloneState);
                txnitems.push(txnitem);
            }
            var ret = yield this.dynamoLib.performTransaction(txnitems);
            if (!ret)
                return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
            else {
                this.dataService.updateMasterList('state', 'delete', null, statelist);
            }
            this.dataService.statelist = [...this.dataService.statelist];
            return { status: 'success' };
        });
    }
    deleteCities(citylist) {
        return __awaiter(this, void 0, void 0, function* () {
            var txnitems = [];
            for (var city of citylist) {
                if (!this.archiveCheckService.validateCityDelete(city)) {
                    return { status: 'error', statuserrorcode: Constants.DML_PARENT_CHECK_FAILED, errordescription: 'City ' + city.name + ' Can not be deleted. Addresses exist for the same!' };
                }
            }
            for (var city of citylist) {
                var cloneCity = cloneDeep(city);
                var txnitem = this.util.getTransactionItem('delete', this.util.getTableName('city'), cloneCity);
                txnitems.push(txnitem);
            }
            var ret = yield this.dynamoLib.performTransaction(txnitems);
            if (!ret)
                return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
            else {
                this.dataService.updateMasterList('city', 'delete', null, citylist);
            }
            this.dataService.citylist = [...this.dataService.citylist];
            return { status: 'success' };
        });
    }
    deleteVendors(vendorlist) {
        return __awaiter(this, void 0, void 0, function* () {
            var txnitems = [];
            for (var vendor of vendorlist) {
                var cloneVendor = cloneDeep(vendor);
                var txnitem = this.util.getTransactionItem('delete', this.util.getTableName('vendor'), cloneVendor);
                txnitems.push(txnitem);
            }
            var ret = yield this.dynamoLib.performTransaction(txnitems);
            if (!ret)
                return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
            else {
                this.dataService.updateMasterList('vendor', 'delete', null, vendorlist);
            }
            this.dataService.vendorlist = [...this.dataService.vendorlist];
            return { status: 'success' };
        });
    }
    deleteAgents(agentlist) {
        return __awaiter(this, void 0, void 0, function* () {
            var txnitems = [];
            for (var agent of agentlist) {
                var cloneAgent = cloneDeep(agent);
                var txnitem = this.util.getTransactionItem('delete', this.util.getTableName('agent'), cloneAgent);
                txnitems.push(txnitem);
            }
            var ret = yield this.dynamoLib.performTransaction(txnitems);
            if (!ret)
                return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
            else {
                this.dataService.updateMasterList('agent', 'delete', null, agentlist);
            }
            this.dataService.agentlist = [...this.dataService.agentlist];
            return { status: 'success' };
        });
    }
    deleteBusinesscustomers(businesscustomerlist) {
        return __awaiter(this, void 0, void 0, function* () {
            var txnitems = [];
            for (var businesscustomer of businesscustomerlist) {
                var cloneBusinesscustomer = cloneDeep(businesscustomer);
                var txnitem = this.util.getTransactionItem('delete', this.util.getTableName('businesscustomer'), cloneBusinesscustomer);
                txnitems.push(txnitem);
            }
            var ret = yield this.dynamoLib.performTransaction(txnitems);
            if (!ret)
                return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
            else {
                this.dataService.updateMasterList('businesscustomer', 'delete', null, businesscustomerlist);
            }
            this.dataService.businesscustomerlist = [...this.dataService.businesscustomerlist];
            return { status: 'success' };
        });
    }
    deleteWarehouses(warehouselist) {
        return __awaiter(this, void 0, void 0, function* () {
            var txnitems = [];
            for (var warehouse of warehouselist) {
                var cloneWarehouse = cloneDeep(warehouse);
                var txnitem = this.util.getTransactionItem('delete', this.util.getTableName('warehouse'), cloneWarehouse);
                txnitems.push(txnitem);
            }
            var ret = yield this.dynamoLib.performTransaction(txnitems);
            if (!ret)
                return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
            else {
                this.dataService.updateMasterList('warehouse', 'delete', null, warehouselist);
            }
            this.dataService.warehouselist = [...this.dataService.warehouselist];
            return { status: 'success' };
        });
    }
    deleteProductcitypricings(productcitypricinglist) {
        return __awaiter(this, void 0, void 0, function* () {
            var txnitems = [];
            for (var productcitypricing of productcitypricinglist) {
                if (!this.archiveCheckService.validateProductcitypricingDelete(productcitypricing)) {
                    return { status: 'error', statuserrorcode: Constants.DML_PARENT_CHECK_FAILED, errordescription: 'Productcitypricing ' + productcitypricing.productname + ' Can not be deleted. Please try again!' };
                }
            }
            for (var productcitypricing of productcitypricinglist) {
                var cloneProductcitypricing = cloneDeep(productcitypricing);
                var txnitem = this.util.getTransactionItem('delete', this.util.getTableName('productcitypricing'), cloneProductcitypricing);
                txnitems.push(txnitem);
            }
            var ret = yield this.dynamoLib.performTransaction(txnitems);
            if (!ret)
                return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
            else {
                this.dataService.updateMasterList('productcitypricing', 'delete', null, productcitypricinglist);
            }
            this.dataService.productcitypricinglist = [...this.dataService.productcitypricinglist];
            return { status: 'success' };
        });
    }
    deleteB2bcustomerpricing(b2bcustomerpricinglist) {
        return __awaiter(this, void 0, void 0, function* () {
            var txnitems = [];
            for (var b2bcustomerpricing of b2bcustomerpricinglist) {
                if (!this.archiveCheckService.validateB2bcustomerpricingdelete(b2bcustomerpricing)) {
                    return { status: 'error', statuserrorcode: Constants.DML_PARENT_CHECK_FAILED, errordescription: 'B2bcustomerpricing ' + b2bcustomerpricing.productname + ' Can not be deleted. Please try again!' };
                }
            }
            for (var b2bcustomerpricing of b2bcustomerpricinglist) {
                var cloneB2bcustomerpricing = cloneDeep(b2bcustomerpricing);
                var txnitem = this.util.getTransactionItem('delete', this.util.getTableName('b2bcustomerpricing'), cloneB2bcustomerpricing);
                txnitems.push(txnitem);
            }
            var ret = yield this.dynamoLib.performTransaction(txnitems);
            if (!ret)
                return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
            else {
                this.dataService.updateMasterList('b2bcustomerpricing', 'delete', null, b2bcustomerpricinglist);
            }
            this.dataService.b2bcustomerpricinglist = [...this.dataService.b2bcustomerpricinglist];
            return { status: 'success' };
        });
    }
    deleteProducts(productlist) {
        return __awaiter(this, void 0, void 0, function* () {
            var txnitems = [];
            for (var product of productlist) {
                var cloneProduct = cloneDeep(product);
                var txnitem = this.util.getTransactionItem('delete', this.util.getTableName('product'), cloneProduct);
                txnitems.push(txnitem);
            }
            var ret = yield this.dynamoLib.performTransaction(txnitems);
            if (!ret)
                return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
            else {
                this.dataService.updateMasterList('product', 'delete', null, productlist);
            }
            this.dataService.productlist = [...this.dataService.productlist];
            return { status: 'success' };
        });
    }
    saveUser(dmltype, user) {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "saveUser++");
            var cloneUser = cloneDeep(user);
            var resp = this.validatorService.validateUser(cloneUser);
            if (resp.status == 'success') {
                var txnitems = [];
                if (dmltype == 'create') {
                    cloneUser.id = "" + this.dynamoLib.getTime();
                    var txnitem = this.util.getTransactionItem('create', this.util.getTableName('user'), cloneUser, "attribute_not_exists(id)");
                    txnitems.push(txnitem);
                }
                else {
                    var txnitem = this.util.getTransactionItem('edit', this.util.getTableName('user'), cloneUser);
                    txnitems.push(txnitem);
                    var auditItem = this.auditService.getUserAuditTrail(cloneUser);
                    if (auditItem) {
                        var txnaudititem = this.util.getAuditTransactionItem(this.util.getTableName('setupaudittrail'), auditItem);
                        txnitems.push(txnaudititem);
                    }
                }
                var ret = yield this.dynamoLib.performTransaction(txnitems);
                if (!ret)
                    return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
                else {
                    this.dataService.updateMasterList('user', dmltype, cloneUser);
                    this.dataService.userlist = [...this.dataService.userlist];
                }
            }
            else
                return resp;
            this.util.log(Constants.LOG_DEBUG, "saveUser--");
            return { status: 'success' };
        });
    }
    saveUsergroup(dmltype, usergroup) {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "saveUsergroup++");
            var cloneUsergroup = cloneDeep(usergroup);
            var resp = this.validatorService.validateUsergroup(cloneUsergroup);
            if (resp.status == 'success') {
                var txnitems = [];
                if (dmltype == 'create') {
                    cloneUsergroup.id = "" + this.dynamoLib.getTime();
                    var txnitem = this.util.getTransactionItem('create', this.util.getTableName('usergroup'), cloneUsergroup, "attribute_not_exists(id)");
                    txnitems.push(txnitem);
                }
                else {
                    var txnitem = this.util.getTransactionItem('edit', this.util.getTableName('usergroup'), cloneUsergroup);
                    txnitems.push(txnitem);
                    var auditItem = this.auditService.getUsergroupAuditTrail(cloneUsergroup);
                    if (auditItem) {
                        var txnaudititem = this.util.getAuditTransactionItem(this.util.getTableName('setupaudittrail'), auditItem);
                        txnitems.push(txnaudititem);
                    }
                }
                var ret = yield this.dynamoLib.performTransaction(txnitems);
                if (!ret)
                    return { status: 'error', statusergrouprorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
                else {
                    this.dataService.updateMasterList('usergroup', dmltype, cloneUsergroup);
                    this.dataService.usergrouplist = [...this.dataService.usergrouplist];
                }
            }
            else
                return resp;
            this.util.log(Constants.LOG_DEBUG, "saveUsergroup--");
            return { status: 'success' };
        });
    }
    deleteBrands(brandlist) {
        return __awaiter(this, void 0, void 0, function* () {
            var txnitems = [];
            for (var brand of brandlist) {
                if (!this.archiveCheckService.validateBrandDelete(brand)) {
                    return { status: 'error', statuserrorcode: Constants.DML_PARENT_CHECK_FAILED, errordescription: 'Brand ' + brand.name + ' Can not be deleted. Product(s) exist for the same!' };
                }
            }
            for (var brand of brandlist) {
                var cloneBrand = cloneDeep(brand);
                var txnitem = this.util.getTransactionItem('delete', this.util.getTableName('brand'), cloneBrand);
                txnitems.push(txnitem);
            }
            var ret = yield this.dynamoLib.performTransaction(txnitems);
            if (!ret)
                return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
            else {
                this.dataService.updateMasterList('brand', 'delete', null, brandlist);
            }
            this.dataService.brandlist = [...this.dataService.brandlist];
            return { status: 'success' };
        });
    }
    deleteProductspecifications(productspecificationlist) {
        return __awaiter(this, void 0, void 0, function* () {
            var txnitems = [];
            for (var productspecification of productspecificationlist) {
                if (!this.archiveCheckService.validateProductspecificationDelete(productspecification)) {
                    return { status: 'error', statuserrorcode: Constants.DML_PARENT_CHECK_FAILED, errordescription: 'Productspecification ' + productspecification.name + ' Can not be deleted. Product(s) exist for the same!' };
                }
            }
            for (var productspecification of productspecificationlist) {
                var cloneProductspecification = cloneDeep(productspecification);
                var txnitem = this.util.getTransactionItem('delete', this.util.getTableName('productspecification'), cloneProductspecification);
                txnitems.push(txnitem);
            }
            var ret = yield this.dynamoLib.performTransaction(txnitems);
            if (!ret)
                return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
            else {
                this.dataService.updateMasterList('productspecification', 'delete', null, productspecificationlist);
            }
            this.dataService.productspecificationlist = [...this.dataService.productspecificationlist];
            return { status: 'success' };
        });
    }
    deleteProductcategories(productcategorylist) {
        return __awaiter(this, void 0, void 0, function* () {
            var txnitems = [];
            for (var productcategory of productcategorylist) {
                if (!this.archiveCheckService.validateProdCategoryDelete(productcategory)) {
                    return { status: 'error', statuserrorcode: Constants.DML_PARENT_CHECK_FAILED, errordescription: 'Product category ' + productcategory.name + ' Can not be deleted. Sub categories exist for the same!' };
                }
            }
            for (var productcategory of productcategorylist) {
                var cloneProductcategory = cloneDeep(productcategory);
                var txnitem = this.util.getTransactionItem('delete', this.util.getTableName('productcategory'), cloneProductcategory);
                txnitems.push(txnitem);
            }
            var ret = yield this.dynamoLib.performTransaction(txnitems);
            if (!ret)
                return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
            else {
                this.dataService.updateMasterList('productcategory', 'delete', null, productcategorylist);
            }
            this.dataService.categorylist = [...this.dataService.categorylist];
            return { status: 'success' };
        });
    }
    deleteProductsubcategorys(productsubcategorylist) {
        return __awaiter(this, void 0, void 0, function* () {
            var txnitems = [];
            for (var productsubcategory of productsubcategorylist) {
                if (!this.archiveCheckService.validateProdSubCategoryDelete(productsubcategory)) {
                    return { status: 'error', statuserrorcode: Constants.DML_PARENT_CHECK_FAILED, errordescription: 'Productsubcategory ' + productsubcategory.name + ' Can not be deleted. Product(s) exist for the same!' };
                }
            }
            for (var productsubcategory of productsubcategorylist) {
                var cloneProductsubcategory = cloneDeep(productsubcategory);
                var txnitem = this.util.getTransactionItem('delete', this.util.getTableName('productsubcategory'), cloneProductsubcategory);
                txnitems.push(txnitem);
            }
            var ret = yield this.dynamoLib.performTransaction(txnitems);
            if (!ret)
                return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
            else {
                this.dataService.updateMasterList('productsubcategory', 'delete', null, productsubcategorylist);
            }
            this.dataService.subcategorylist = [...this.dataService.subcategorylist];
            return { status: 'success' };
        });
    }
    /***
     * SAVE APIS
     */
    //State API  
    saveState(dmltype, state) {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "saveState++");
            var cloneState = cloneDeep(state);
            var resp = this.validatorService.validateState(cloneState);
            if (resp.status == 'success') {
                var txnitems = [];
                if (dmltype == 'create') {
                    cloneState.id = "" + this.dynamoLib.getTime();
                    var txnitem = this.util.getTransactionItem('create', this.util.getTableName('state'), cloneState, "attribute_not_exists(id)");
                    txnitems.push(txnitem);
                }
                else {
                    var txnitem = this.util.getTransactionItem('edit', this.util.getTableName('state'), cloneState);
                    txnitems.push(txnitem);
                    var auditItem = this.auditService.getStateAuditTrail(cloneState);
                    if (auditItem) {
                        var txnaudititem = this.util.getAuditTransactionItem(this.util.getTableName('setupaudittrail'), auditItem);
                        txnitems.push(txnaudititem);
                    }
                }
                var ret = yield this.dynamoLib.performTransaction(txnitems);
                if (!ret)
                    return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
                else {
                    this.dataService.updateMasterList('state', dmltype, cloneState);
                    this.dataService.statelist = [...this.dataService.statelist];
                }
            }
            else
                return resp;
            this.util.log(Constants.LOG_DEBUG, "saveState--");
            return { status: 'success' };
        });
    }
    saveCity(dmltype, city) {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "saveCity++");
            var cloneCity = cloneDeep(city);
            var resp = this.validatorService.validateCity(cloneCity);
            if (resp.status == 'success') {
                var txnitems = [];
                if (dmltype == 'create') {
                    cloneCity.id = "" + this.dynamoLib.getTime();
                    var txnitem = this.util.getTransactionItem('create', this.util.getTableName('city'), cloneCity, "attribute_not_exists(id)");
                    txnitems.push(txnitem);
                }
                else {
                    var txnitem = this.util.getTransactionItem('edit', this.util.getTableName('city'), cloneCity);
                    txnitems.push(txnitem);
                    var auditItem = this.auditService.getCityAuditTrail(cloneCity);
                    if (auditItem) {
                        var txnaudititem = this.util.getAuditTransactionItem(this.util.getTableName('setupaudittrail'), auditItem);
                        txnitems.push(txnaudititem);
                    }
                }
                var ret = yield this.dynamoLib.performTransaction(txnitems);
                if (!ret)
                    return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
                else {
                    this.dataService.updateMasterList('city', dmltype, cloneCity);
                    this.dataService.citylist = [...this.dataService.citylist];
                }
            }
            else
                return resp;
            this.util.log(Constants.LOG_DEBUG, "saveCity--");
            return { status: 'success' };
        });
    }
    saveVendor(dmltype, vendor) {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "saveVendor++");
            var cloneVendor = cloneDeep(vendor);
            var resp = this.validatorService.validateVendor(cloneVendor);
            if (resp.status == 'success') {
                var txnitems = [];
                if (dmltype == 'create') {
                    cloneVendor.id = "" + this.dynamoLib.getTime();
                    var txnitem = this.util.getTransactionItem('create', this.util.getTableName('vendor'), cloneVendor, "attribute_not_exists(id)");
                    txnitems.push(txnitem);
                }
                else {
                    var txnitem = this.util.getTransactionItem('edit', this.util.getTableName('vendor'), cloneVendor);
                    txnitems.push(txnitem);
                    var auditItem = this.auditService.getVendorAuditTrail(cloneVendor);
                    if (auditItem) {
                        var txnaudititem = this.util.getAuditTransactionItem(this.util.getTableName('setupaudittrail'), auditItem);
                        txnitems.push(txnaudititem);
                    }
                }
                var ret = yield this.dynamoLib.performTransaction(txnitems);
                if (!ret)
                    return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
                else {
                    this.dataService.updateMasterList('vendor', dmltype, cloneVendor);
                    this.dataService.vendorlist = [...this.dataService.vendorlist];
                }
            }
            else
                return resp;
            this.util.log(Constants.LOG_DEBUG, "saveVendor--");
            return { status: 'success' };
        });
    }
    saveAgent(dmltype, agent) {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "saveAgent++");
            var cloneAgent = cloneDeep(agent);
            var resp = this.validatorService.validateAgent(cloneAgent);
            if (resp.status == 'success') {
                var txnitems = [];
                if (dmltype == 'create') {
                    cloneAgent.id = "" + this.dynamoLib.getTime();
                    var txnitem = this.util.getTransactionItem('create', this.util.getTableName('agent'), cloneAgent, "attribute_not_exists(id)");
                    txnitems.push(txnitem);
                }
                else {
                    var txnitem = this.util.getTransactionItem('edit', this.util.getTableName('agent'), cloneAgent);
                    txnitems.push(txnitem);
                    var auditItem = this.auditService.getAgentAuditTrail(cloneAgent);
                    if (auditItem) {
                        var txnaudititem = this.util.getAuditTransactionItem(this.util.getTableName('setupaudittrail'), auditItem);
                        txnitems.push(txnaudititem);
                    }
                }
                var ret = yield this.dynamoLib.performTransaction(txnitems);
                if (!ret)
                    return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
                else {
                    this.dataService.updateMasterList('agent', dmltype, cloneAgent);
                    this.dataService.agentlist = [...this.dataService.agentlist];
                }
            }
            else
                return resp;
            this.util.log(Constants.LOG_DEBUG, "saveAgent--");
            return { status: 'success' };
        });
    }
    saveBrand(dmltype, brand) {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "saveBrand++");
            var cloneBrand = cloneDeep(brand);
            var resp = this.validatorService.validateBrand(cloneBrand);
            if (resp.status == 'success') {
                var txnitems = [];
                if (dmltype == 'create') {
                    cloneBrand.id = "" + this.dynamoLib.getTime();
                    var txnitem = this.util.getTransactionItem('create', this.util.getTableName('brand'), cloneBrand, "attribute_not_exists(id)");
                    txnitems.push(txnitem);
                }
                else {
                    var txnitem = this.util.getTransactionItem('edit', this.util.getTableName('brand'), cloneBrand);
                    txnitems.push(txnitem);
                    var auditItem = this.auditService.getBrandAuditTrail(cloneBrand);
                    if (auditItem) {
                        var txnaudititem = this.util.getAuditTransactionItem(this.util.getTableName('setupaudittrail'), auditItem);
                        txnitems.push(txnaudititem);
                    }
                }
                var ret = yield this.dynamoLib.performTransaction(txnitems);
                if (!ret)
                    return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
                else {
                    this.dataService.updateMasterList('brand', dmltype, cloneBrand);
                    this.dataService.brandlist = [...this.dataService.brandlist];
                }
            }
            else
                return resp;
            this.util.log(Constants.LOG_DEBUG, "saveBrand--");
            return { status: 'success' };
        });
    }
    saveProductspecification(dmltype, productspecification) {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "saveProductspecification++");
            var cloneProductspecification = cloneDeep(productspecification);
            var resp = this.validatorService.validateProductspecification(cloneProductspecification);
            if (resp.status == 'success') {
                var txnitems = [];
                if (dmltype == 'create') {
                    cloneProductspecification.id = "" + this.dynamoLib.getTime();
                    var txnitem = this.util.getTransactionItem('create', this.util.getTableName('productspecification'), cloneProductspecification, "attribute_not_exists(id)");
                    txnitems.push(txnitem);
                }
                else {
                    var txnitem = this.util.getTransactionItem('edit', this.util.getTableName('productspecification'), cloneProductspecification);
                    txnitems.push(txnitem);
                    var auditItem = this.auditService.getProductspecificationAuditTrail(cloneProductspecification);
                    if (auditItem) {
                        var txnaudititem = this.util.getAuditTransactionItem(this.util.getTableName('setupaudittrail'), auditItem);
                        txnitems.push(txnaudititem);
                    }
                }
                var ret = yield this.dynamoLib.performTransaction(txnitems);
                if (!ret)
                    return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
                else {
                    this.dataService.updateMasterList('productspecification', dmltype, cloneProductspecification);
                    this.dataService.productspecificationlist = [...this.dataService.productspecificationlist];
                }
            }
            else
                return resp;
            this.util.log(Constants.LOG_DEBUG, "saveProductspecification--");
            return { status: 'success' };
        });
    }
    saveProductcitypricing(dmltype, productcitypricing) {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "saveProductcitypricing++");
            var cloneProductcitypricing = cloneDeep(productcitypricing);
            var resp = this.validatorService.validateProductcitypricing(cloneProductcitypricing);
            if (resp.status == 'success') {
                var txnitems = [];
                if (dmltype == 'create') {
                    cloneProductcitypricing.id = "" + this.dynamoLib.getTime();
                    var txnitem = this.util.getTransactionItem('create', this.util.getTableName('productcitypricing'), cloneProductcitypricing, "attribute_not_exists(id)");
                    txnitems.push(txnitem);
                }
                else {
                    var txnitem = this.util.getTransactionItem('edit', this.util.getTableName('productcitypricing'), cloneProductcitypricing);
                    txnitems.push(txnitem);
                    var auditItem = this.auditService.getProductcitypricingAuditTrail(cloneProductcitypricing);
                    if (auditItem) {
                        var txnaudititem = this.util.getAuditTransactionItem(this.util.getTableName('setupaudittrail'), auditItem);
                        txnitems.push(txnaudititem);
                    }
                }
                var ret = yield this.dynamoLib.performTransaction(txnitems);
                if (!ret)
                    return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
                else {
                    this.dataService.updateMasterList('productcitypricing', dmltype, cloneProductcitypricing);
                    this.dataService.productcitypricinglist = [...this.dataService.productcitypricinglist];
                }
            }
            else
                return resp;
            this.util.log(Constants.LOG_DEBUG, "saveProductcitypricing--");
            return { status: 'success' };
        });
    }
    saveB2bcustomerpricing(dmltype, b2bcustomerpricing) {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "saveB2bcustomerpricing++");
            var cloneB2bcustomerpricing = cloneDeep(b2bcustomerpricing);
            var resp = this.validatorService.validateB2bcustomerpricing(cloneB2bcustomerpricing);
            if (resp.status == 'success') {
                var txnitems = [];
                if (dmltype == 'create') {
                    cloneB2bcustomerpricing.id = "" + this.dynamoLib.getTime();
                    var txnitem = this.util.getTransactionItem('create', this.util.getTableName('b2bcustomerpricing'), cloneB2bcustomerpricing, "attribute_not_exists(id)");
                    txnitems.push(txnitem);
                }
                else {
                    var txnitem = this.util.getTransactionItem('edit', this.util.getTableName('b2bcustomerpricing'), cloneB2bcustomerpricing);
                    txnitems.push(txnitem);
                    var auditItem = this.auditService.getB2bcustomerpricingAuditTrail(cloneB2bcustomerpricing);
                    if (auditItem) {
                        var txnaudititem = this.util.getAuditTransactionItem(this.util.getTableName('setupaudittrail'), auditItem);
                        txnitems.push(txnaudititem);
                    }
                }
                var ret = yield this.dynamoLib.performTransaction(txnitems);
                if (!ret)
                    return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
                else {
                    this.dataService.updateMasterList('b2bcustomerpricing', dmltype, cloneB2bcustomerpricing);
                    this.dataService.b2bcustomerpricinglist = [...this.dataService.b2bcustomerpricinglist];
                }
            }
            else
                return resp;
            this.util.log(Constants.LOG_DEBUG, "saveB2bcustomerpricing--");
            return { status: 'success' };
        });
    }
    saveBusinesscustomer(dmltype, businesscustomer) {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "saveBusinesscustomer++");
            var cloneBusinesscustomer = cloneDeep(businesscustomer);
            var resp = this.validatorService.validateBusinesscustomer(cloneBusinesscustomer);
            if (resp.status == 'success') {
                var txnitems = [];
                if (dmltype == 'create') {
                    cloneBusinesscustomer.id = "" + this.dynamoLib.getTime();
                    var txnitem = this.util.getTransactionItem('create', this.util.getTableName('businesscustomer'), cloneBusinesscustomer, "attribute_not_exists(id)");
                    txnitems.push(txnitem);
                }
                else {
                    var txnitem = this.util.getTransactionItem('edit', this.util.getTableName('businesscustomer'), cloneBusinesscustomer);
                    txnitems.push(txnitem);
                    var auditItem = this.auditService.getBusinesscustomerAuditTrail(cloneBusinesscustomer);
                    if (auditItem) {
                        var txnaudititem = this.util.getAuditTransactionItem(this.util.getTableName('setupaudittrail'), auditItem);
                        txnitems.push(txnaudititem);
                    }
                }
                var ret = yield this.dynamoLib.performTransaction(txnitems);
                if (!ret)
                    return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
                else {
                    this.dataService.updateMasterList('businesscustomer', dmltype, cloneBusinesscustomer);
                    this.dataService.businesscustomerlist = [...this.dataService.businesscustomerlist];
                }
            }
            else
                return resp;
            this.util.log(Constants.LOG_DEBUG, "saveBusinesscustomer--");
            return { status: 'success' };
        });
    }
    getClone(object) {
        return cloneDeep(object);
    }
    saveCustomer(dmltype, customer) {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "saveCustomer++");
            var cloneCustomer = cloneDeep(customer);
            var resp = this.validatorService.validateCustomer(cloneCustomer);
            if (resp.status == 'success') {
                var txnitems = [];
                if (dmltype == 'create') {
                    cloneCustomer.id = "" + this.dynamoLib.getTime();
                    var txnitem = this.util.getTransactionItem('create', this.util.getTableName('customer'), cloneCustomer, "attribute_not_exists(id)");
                    txnitems.push(txnitem);
                }
                else {
                    var txnitem = this.util.getTransactionItem('edit', this.util.getTableName('customer'), cloneCustomer);
                    txnitems.push(txnitem);
                    var auditItem = this.auditService.getCustomerAuditTrail(cloneCustomer);
                    if (auditItem) {
                        var txnaudititem = this.util.getAuditTransactionItem(this.util.getTableName('setupaudittrail'), auditItem);
                        txnitems.push(txnaudititem);
                    }
                }
                var ret = yield this.dynamoLib.performTransaction(txnitems);
                if (!ret)
                    return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
            }
            else
                return resp;
            this.util.log(Constants.LOG_DEBUG, "saveCustomer--");
            this.dataService.loggedincustomer = cloneCustomer;
            return { status: 'success' };
        });
    }
    saveProduct(dmltype, product) {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "saveProduct++");
            var cloneProduct = cloneDeep(product);
            var resp = this.validatorService.validateProduct(cloneProduct);
            if (resp.status == 'success') {
                var txnitems = [];
                if (dmltype == 'create') {
                    cloneProduct.id = "" + this.dynamoLib.getTime();
                    var txnitem = this.util.getTransactionItem('create', this.util.getTableName('product'), cloneProduct, "attribute_not_exists(id)");
                    txnitems.push(txnitem);
                }
                else {
                    var txnitem = this.util.getTransactionItem('edit', this.util.getTableName('product'), cloneProduct);
                    txnitems.push(txnitem);
                    var auditItem = this.auditService.getProductAuditTrail(cloneProduct);
                    if (auditItem) {
                        var txnaudititem = this.util.getAuditTransactionItem(this.util.getTableName('setupaudittrail'), auditItem);
                        txnitems.push(txnaudititem);
                    }
                }
                var ret = yield this.dynamoLib.performTransaction(txnitems);
                if (!ret)
                    return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
                else {
                    this.dataService.updateMasterList('product', dmltype, cloneProduct);
                    this.dataService.productlist = [...this.dataService.productlist];
                }
            }
            else
                return resp;
            this.util.log(Constants.LOG_DEBUG, "saveProduct--");
            return { status: 'success' };
        });
    }
    saveProductcategory(dmltype, productcategory) {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "saveProductcategory++");
            var cloneProductcategory = cloneDeep(productcategory);
            var resp = this.validatorService.validateProductcategory(cloneProductcategory);
            if (resp.status == 'success') {
                var txnitems = [];
                if (dmltype == 'create') {
                    cloneProductcategory.id = "" + this.dynamoLib.getTime();
                    var txnitem = this.util.getTransactionItem('create', this.util.getTableName('productcategory'), cloneProductcategory, "attribute_not_exists(id)");
                    txnitems.push(txnitem);
                }
                else {
                    var txnitem = this.util.getTransactionItem('edit', this.util.getTableName('productcategory'), cloneProductcategory);
                    txnitems.push(txnitem);
                    var auditItem = this.auditService.getProductcategoryAuditTrail(cloneProductcategory);
                    if (auditItem) {
                        var txnaudititem = this.util.getAuditTransactionItem(this.util.getTableName('setupaudittrail'), auditItem);
                        txnitems.push(txnaudititem);
                    }
                }
                var ret = yield this.dynamoLib.performTransaction(txnitems);
                if (!ret)
                    return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
                else {
                    this.dataService.updateMasterList('productcategory', dmltype, cloneProductcategory);
                    this.dataService.categorylist = [...this.dataService.categorylist];
                }
            }
            else
                return resp;
            this.util.log(Constants.LOG_DEBUG, "saveProductcategory--");
            return { status: 'success' };
        });
    }
    saveProductsubcategory(dmltype, productsubcategory) {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "saveProductsubcategory++");
            var cloneProductsubcategory = cloneDeep(productsubcategory);
            var resp = this.validatorService.validateProductsubcategory(cloneProductsubcategory);
            if (resp.status == 'success') {
                var txnitems = [];
                if (dmltype == 'create') {
                    cloneProductsubcategory.id = "" + this.dynamoLib.getTime();
                    var txnitem = this.util.getTransactionItem('create', this.util.getTableName('productsubcategory'), cloneProductsubcategory, "attribute_not_exists(id)");
                    txnitems.push(txnitem);
                }
                else {
                    var txnitem = this.util.getTransactionItem('edit', this.util.getTableName('productsubcategory'), cloneProductsubcategory);
                    txnitems.push(txnitem);
                    var auditItem = this.auditService.getProductsubcategoryAuditTrail(cloneProductsubcategory);
                    if (auditItem) {
                        var txnaudititem = this.util.getAuditTransactionItem(this.util.getTableName('setupaudittrail'), auditItem);
                        txnitems.push(txnaudititem);
                    }
                }
                var ret = yield this.dynamoLib.performTransaction(txnitems);
                if (!ret)
                    return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
                else {
                    this.dataService.updateMasterList('productsubcategory', dmltype, cloneProductsubcategory);
                    this.dataService.subcategorylist = [...this.dataService.subcategorylist];
                }
            }
            else
                return resp;
            this.util.log(Constants.LOG_DEBUG, "saveProductsubcategory--");
            return { status: 'success' };
        });
    }
    saveWarehouse(dmltype, warehouse) {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "saveWarehouse++");
            var cloneWarehouse = cloneDeep(warehouse);
            var resp = this.validatorService.validateWarehouse(cloneWarehouse);
            if (resp.status == 'success') {
                var txnitems = [];
                if (dmltype == 'create') {
                    cloneWarehouse.id = "" + this.dynamoLib.getTime();
                    var txnitem = this.util.getTransactionItem('create', this.util.getTableName('warehouse'), cloneWarehouse, "attribute_not_exists(id)");
                    txnitems.push(txnitem);
                }
                else {
                    var txnitem = this.util.getTransactionItem('edit', this.util.getTableName('warehouse'), cloneWarehouse);
                    txnitems.push(txnitem);
                    var auditItem = this.auditService.getWarehouseAuditTrail(cloneWarehouse);
                    if (auditItem) {
                        var txnaudititem = this.util.getAuditTransactionItem(this.util.getTableName('setupaudittrail'), auditItem);
                        txnitems.push(txnaudititem);
                    }
                }
                var ret = yield this.dynamoLib.performTransaction(txnitems);
                if (!ret)
                    return { status: 'error', statuserrorcode: Constants.DB_WRITE_FAILED, errordescription: 'Error writing to database' };
                else {
                    this.dataService.updateMasterList('warehouse', dmltype, cloneWarehouse);
                    this.dataService.warehouselist = [...this.dataService.warehouselist];
                }
            }
            else
                return resp;
            this.util.log(Constants.LOG_DEBUG, "saveWarehouse--");
            return { status: 'success' };
        });
    }
}
SetupService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: SetupService, deps: [{ token: ValidatorService }, { token: ArchivecheckService }, { token: AuditService }, { token: AppdataService }, { token: UtilService }, { token: i3.DynamoLibService }], target: i0.ɵɵFactoryTarget.Injectable });
SetupService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: SetupService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: SetupService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ValidatorService }, { type: ArchivecheckService }, { type: AuditService }, { type: AppdataService }, { type: UtilService }, { type: i3.DynamoLibService }]; } });

class LoginService {
    constructor(dataService, util, dblib) {
        this.dataService = dataService;
        this.util = util;
        this.dblib = dblib;
    }
    findByMobile(mobileno) {
        return __awaiter(this, void 0, void 0, function* () {
            var tablename = this.util.getTableName('vendor');
            var conditionexpression = "whatasappnummber  = :v_mobileno";
            var attribparams = { ":v_mobileno": mobileno };
            var retlist = yield this.dblib.queryDB(tablename, "mobileno-index", conditionexpression, null, null, attribparams, null, null, null, true, true);
            if (retlist && retlist.length > 0) {
                return retlist[0];
            }
            else {
                return null;
            }
        });
    }
    findVendorByMobile(mobileno) {
        return __awaiter(this, void 0, void 0, function* () {
            var vendor = null;
            vendor = yield this.findByMobile(mobileno);
            if (vendor) {
                this.dataService.loggedinvendor = vendor;
                return { status: 'success' };
            }
            else {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Login failed!' };
            }
        });
    }
    findByUserPass(table, username, userpass) {
        return __awaiter(this, void 0, void 0, function* () {
            var tablename = this.util.getTableName(table);
            var conditionexpression = "username  = :v_username and userpass = :v_pass ";
            var attribparams = { ":v_username": username, ":v_pass": userpass };
            var retlist = yield this.dblib.queryDB(tablename, "username-userpass-index", conditionexpression, null, null, attribparams, null, null, null, true, true);
            if (retlist && retlist.length > 0) {
                return retlist[0];
            }
            else {
                return null;
            }
        });
    }
    loginAdmin(username, userpass) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('LOGIN ADMIN CALLEDD');
            var user = yield this.findByUserPass('user', username, userpass);
            this.util.log(Constants.LOG_DEBUG, "loginAdmin++");
            console.log('**** Setting logged in user to ' + JSON.stringify(user));
            if (user) {
                console.log('**** Setting logged in user to ' + JSON.stringify(user));
                this.dataService.loggedinuser = user;
                return { status: 'success' };
            }
            else {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Login failed!' };
            }
        });
    }
    findCustomerByMobile(mobileno) {
        return __awaiter(this, void 0, void 0, function* () {
            var tablename = this.util.getTableName('customer');
            var conditionexpression = "mobileno  = :v_mobileno";
            var attribparams = { ":v_mobileno": mobileno };
            var retlist = yield this.dblib.queryDB(tablename, "mobileno-index", conditionexpression, null, null, attribparams, null, null, null, true, true);
            if (retlist && retlist.length > 0) {
                return retlist[0];
            }
            else {
                return null;
            }
        });
    }
    logout() {
        this.dataService.isloggedin = false;
        this.dataService.loggedinvendor = null;
    }
}
LoginService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: LoginService, deps: [{ token: AppdataService }, { token: UtilService }, { token: i3.DynamoLibService }], target: i0.ɵɵFactoryTarget.Injectable });
LoginService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: LoginService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: LoginService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: AppdataService }, { type: UtilService }, { type: i3.DynamoLibService }]; } });

class OrderService {
    constructor(validatorService, archiveCheckService, auditService, dataService, util, dynamoLib) {
        this.validatorService = validatorService;
        this.archiveCheckService = archiveCheckService;
        this.auditService = auditService;
        this.dataService = dataService;
        this.util = util;
        this.dynamoLib = dynamoLib;
        this.outskirtsdelivery = false;
    }
    setCartTotalstoZero() {
        this.cart.sumitemcount = 0;
        this.cart.sumitemamount = 0;
        this.cart.sumitemdiscountvalue = 0;
        this.cart.sumitemtaxableamount = 0;
        this.cart.sumitemcgst = 0;
        this.cart.sumitemigst = 0;
        this.cart.sumitemsgst = 0;
        this.cart.sumitemtaxes = 0;
        this.cart.sumitemgross = 0;
        this.cart.sumitempayable = 0;
        this.cart.netpayable = 0;
        this.cart.sumdepositamount = 0;
    }
    initializeCart() {
        this.cart = {};
        this.cart.lineitems = [];
        this.setCartTotalstoZero();
        this.b2bcustomer = null;
        this.cityid = null;
        this.cart.outskirtsdelivery = false;
    }
    getItemfromCart(productid) {
        for (var item of this.cart.lineitems) {
            if (item.productid == productid)
                return item;
        }
        return null;
    }
    removeLineItem(productid) {
        for (var i = 0; i < this.cart.lineitems.length; i++) {
            var item = this.cart.lineitems[i];
            if (item.productid == productid) {
                this.cart.lineitems.splice(i, 1);
            }
        }
        this.recomputeCart();
        return { status: 'success' };
    }
    removeItemFromCart(productid) {
        for (var i = 0; i < this.cart.lineitems.length; i++) {
            var item = this.cart.lineitems[i];
            if (item.productid == productid) {
                if (item.quantity > 1) {
                    item.quantity = item.quantity - 1;
                    if (item.billingtype == 'SALE') {
                        item.itemamount = item.rate * item.quantity;
                        if (item.itemdiscountpercentage > 0) {
                            item.itemdiscountvalue = this.util.round(item.itemamount * item.itemdiscountpercentage / 100, 2);
                        }
                        item.itemgross = this.util.round(item.itemamount - item.itemdiscountvalue, 2);
                    }
                    else {
                        item.itemamount = item.rate * item.rentperiod * item.quantity;
                        item.depositamount = item.depositrate * item.quantity;
                        if (item.itemdiscountpercentage > 0) {
                            item.itemdiscountvalue = this.util.round(item.itemamount * item.itemdiscountpercentage / 100, 2);
                        }
                        item.itemgross = this.util.round(item.itemamount + item.depositamount - item.itemdiscountvalue, 2);
                    }
                    item.transportationcost = item.transporationrate * item.quantity;
                    item.itemtaxableamount = this.util.round(item.itemamount - item.itemdiscountvalue, 2);
                    this.computeTaxesOnLineitem(item);
                    item.totalpayableamount = this.util.round(item.itemgross, 2);
                    item.transportationcost = item.transporationrate; //* item.quantity;
                }
                else {
                    this.cart.lineitems.splice(i, 1);
                }
            }
        }
        this.recomputeCart();
        return { status: 'success' };
    }
    setRentPeriod(rentperiod, product, item) {
        switch (rentperiod) {
            case '1w':
                item.rate = product.productpricing.retailweeklyrent;
                item.rentperiod = 1;
                item.rentperiodunit = 'week';
                break;
            case '1m':
                item.rentperiod = 1;
                item.rate = product.productpricing.retailmonthlyrent;
                item.rentperiodunit = 'month';
                break;
            case '3m':
                item.rentperiod = 3;
                item.rate = product.productpricing.retailmonthlyrent;
                item.rentperiodunit = 'month';
                break;
            case '6m':
                item.rentperiod = 6;
                item.rate = product.productpricing.retailmonthlyrent;
                item.rentperiodunit = 'month';
                break;
            case '1y':
                item.rentperiod = 12;
                item.rate = product.productpricing.retailmonthlyrent;
                item.rentperiodunit = 'month';
                break;
        }
    }
    setRentPeriodB2B(rentperiod, b2bPricing, item) {
        switch (rentperiod) {
            case '1w':
                item.rate = b2bPricing.weeklyrent;
                item.rentperiod = 1;
                item.rentperiodunit = 'week';
                break;
            case '1m':
                item.rentperiod = 1;
                item.rate = b2bPricing.monthlyrent;
                item.rentperiodunit = 'month';
                break;
            case '3m':
                item.rentperiod = 3;
                item.rate = b2bPricing.monthlyrent;
                item.rentperiodunit = 'month';
                break;
            case '6m':
                item.rentperiod = 6;
                item.rate = b2bPricing.monthlyrent;
                item.rentperiodunit = 'month';
                break;
            case '1y':
                item.rentperiod = 12;
                item.rate = b2bPricing.monthlyrent;
                item.rentperiodunit = 'month';
                break;
        }
    }
    createNewCartItem(product, billingtype, rentperiod, customertype, ccorder) {
        var item = {};
        item.productid = product.id;
        item.productname = product.name;
        item.productcode = product.code;
        item.brandname = product.brandname;
        item.modelno = product.modelno;
        item.brandid = product.brandid;
        if (product.imagefiles && product.imagefiles.length > 0)
            item.imageurl = product.imagefiles[0];
        item.quantity = 1;
        item.billingtype = billingtype;
        item.itemdiscountpercentage = 0;
        item.itemdiscountvalue = 0;
        if (customertype == 'corporate') {
            var b2bcustomerpricing = this.dataService.getB2bPricing(product.id, this.b2bcustomer.id, this.cityid);
            if (!b2bcustomerpricing)
                return null;
            if (billingtype == 'RENT') {
                this.setRentPeriodB2B(rentperiod, b2bcustomerpricing, item);
                item.depositrate = b2bcustomerpricing.depositforrent;
                item.depositamount = item.depositrate;
                item.itemamount = item.rate * item.rentperiod;
                item.itemgross = this.util.round(item.itemamount + item.depositamount, 2);
                item.gstpercent = product.gstpercentagerent;
            }
            else {
                item.rate = b2bcustomerpricing.sellingrate;
                item.itemamount = item.rate;
                item.gstpercent = product.gstpercentage;
                item.itemgross = this.util.round(item.itemamount, 2);
            }
            if (item.rate <= 0) {
                return null;
            }
            if (b2bcustomerpricing.transportationcost && b2bcustomerpricing.transportationcost > 0) {
                item.transporationrate = b2bcustomerpricing.transportationcost;
                item.transportationcost = item.transporationrate;
            }
            else {
                item.transporationrate = 0;
                item.transportationcost = 0;
            }
            if (b2bcustomerpricing.outskirttransportationcost && b2bcustomerpricing.outskirttransportationcost > 0) {
                item.outskirtstransporationrate = b2bcustomerpricing.outskirttransportationcost;
                item.outskirtstransportationcost = item.outskirtstransporationrate;
            }
            else {
                item.outskirtstransporationrate = 0;
                item.outskirtstransportationcost = 0;
            }
        }
        else {
            var cartproduct = cloneDeep(product);
            if (ccorder) {
                this.dataService.setCityPricingForProduct(cartproduct, this.cityid);
            }
            if (billingtype == 'RENT') {
                this.setRentPeriod(rentperiod, cartproduct, item);
                if (!ccorder) {
                    var location = localStorage.getItem('selectedcity');
                    if (location != 'Mumbai')
                        item.depositrate = product.productpricing.depositforrent;
                    else
                        item.depositrate = 0; // product.productpricing.depositforrent;
                }
                else {
                    item.depositrate = cartproduct.productpricing.depositforrent;
                }
                item.depositamount = item.depositrate;
                item.itemamount = item.rate * item.rentperiod;
                //console.log ('DEPOSIT RATE ' + item.depositamount);
                if (cartproduct.productpricing.retaildiscountrent && cartproduct.productpricing.retaildiscountrent > 0) {
                    item.itemdiscountpercentage = cartproduct.productpricing.retaildiscountrent;
                    item.itemdiscountvalue = this.util.round(item.itemamount * item.itemdiscountpercentage / 100, 2);
                }
                item.itemgross = this.util.round(item.itemamount + item.depositamount - item.itemdiscountvalue, 2);
                item.gstpercent = cartproduct.gstpercentagerent;
            }
            else {
                item.rate = cartproduct.productpricing.retailsellingrate;
                item.itemamount = item.rate;
                item.gstpercent = cartproduct.gstpercentage;
                if (cartproduct.productpricing.retaildiscountbuy && cartproduct.productpricing.retaildiscountbuy > 0) {
                    item.itemdiscountpercentage = cartproduct.productpricing.retaildiscountbuy;
                    item.itemdiscountvalue = this.util.round(item.itemamount * item.itemdiscountpercentage / 100, 2);
                }
                item.itemgross = this.util.round(item.itemamount - item.itemdiscountvalue, 2);
            }
            if (cartproduct.productpricing.transportationcost && cartproduct.productpricing.transportationcost > 0) {
                item.transporationrate = cartproduct.productpricing.transportationcost;
                item.transportationcost = item.transporationrate;
            }
            else {
                item.transporationrate = 0;
                item.transportationcost = 0;
            }
            if (cartproduct.productpricing.outskirttransportationcost && cartproduct.productpricing.outskirttransportationcost > 0) {
                item.outskirtstransporationrate = cartproduct.productpricing.outskirttransportationcost;
                item.outskirtstransportationcost = item.outskirtstransporationrate;
            }
            else {
                item.outskirtstransporationrate = 0;
                item.outskirtstransportationcost = 0;
            }
        }
        //item.itemdiscountpercentage = 0;
        //item.itemdiscountvalue = 0;
        item.itemtaxableamount = this.util.round(item.itemamount - item.itemdiscountvalue, 2);
        this.computeTaxesOnLineitem(item);
        item.totalpayableamount = this.util.round(item.itemgross, 2);
        return item;
    }
    applyDepositOnCartItem(item, depositrate) {
        var curitem = this.getItemfromCart(item.productid);
        if (curitem) {
            curitem.depositrate = depositrate;
            curitem.depositamount = item.depositrate * item.quantity;
            curitem.itemgross = this.util.round(curitem.itemamount + curitem.depositamount - curitem.itemdiscountvalue, 2);
            curitem.totalpayableamount = this.util.round(curitem.itemgross, 2);
            curitem.manualdepositentry = true;
            this.recomputeCart();
        }
    }
    applyDiscountOnCartItem(item, discountinpercent, otp, amountdiscount) {
        var curitem = this.getItemfromCart(item.productid);
        if (curitem) {
            if (amountdiscount) {
                var discountamount = discountinpercent;
                discountinpercent = this.util.round(discountamount / curitem.itemamount * 100, 2);
            }
            curitem.itemdiscountpercentage = discountinpercent;
            curitem.itemdiscountvalue = this.util.round(curitem.itemamount * curitem.itemdiscountpercentage / 100, 2);
            if (curitem.billingtype == 'SALE')
                curitem.itemgross = this.util.round(curitem.itemamount - curitem.itemdiscountvalue, 2);
            else
                curitem.itemgross = this.util.round(curitem.itemamount + curitem.depositamount - curitem.itemdiscountvalue, 2);
            curitem.itemtaxableamount = this.util.round(curitem.itemamount - curitem.itemdiscountvalue, 2);
            this.computeTaxesOnLineitem(curitem);
            curitem.totalpayableamount = this.util.round(curitem.itemgross, 2);
            curitem.discountotp = otp;
        }
        this.recomputeCart();
        return { status: 'success' };
    }
    addItemtoCart(productid, currentmode, rentperiod, customertype, ccorder) {
        if (customertype && customertype == 'corporate') {
            if (this.b2bcustomer == null) {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please set the corporate customer before adding items to cart!' };
            }
        }
        if (ccorder && !this.cityid) {
            return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please set the city before adding items !' };
        }
        var curitem = this.getItemfromCart(productid);
        if (curitem) {
            //if(curitem.quantity >= 5) return; 
            if (curitem.billingtype != currentmode) {
                if (curitem.billingtype == 'SALE')
                    return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'This item is already added for buying, same can not be added for rent!' };
                else
                    return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'This item is already added for rent, same can not be added for buying!' };
            }
            curitem.quantity = curitem.quantity + 1;
            if (curitem.billingtype == 'SALE') {
                curitem.itemamount = curitem.rate * curitem.quantity;
                if (curitem.itemdiscountpercentage > 0) {
                    curitem.itemdiscountvalue = this.util.round(curitem.itemamount * curitem.itemdiscountpercentage / 100, 2);
                }
                curitem.itemgross = this.util.round(curitem.itemamount - curitem.itemdiscountvalue, 2);
            }
            else {
                curitem.itemamount = curitem.rate * curitem.rentperiod * curitem.quantity;
                curitem.depositamount = curitem.depositrate * curitem.quantity;
                if (curitem.itemdiscountpercentage > 0) {
                    curitem.itemdiscountvalue = this.util.round(curitem.itemamount * curitem.itemdiscountpercentage / 100, 2);
                }
                curitem.itemgross = this.util.round(curitem.itemamount + curitem.depositamount - curitem.itemdiscountvalue, 2);
            }
            curitem.itemtaxableamount = this.util.round(curitem.itemamount - curitem.itemdiscountvalue, 2);
            this.computeTaxesOnLineitem(curitem);
            curitem.totalpayableamount = this.util.round(curitem.itemgross, 2);
            //curitem.transportationcost = curitem.transporationrate * curitem.quantity;
        }
        else {
            var product = this.dataService.getProductForId(productid);
            if (!product) {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please choose valid product!' };
            }
            var lineitem = this.createNewCartItem(product, currentmode, rentperiod, customertype, ccorder);
            if (lineitem == null) {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Please check if pricing is configured!' };
            }
            this.cart.lineitems.push(lineitem);
        }
        this.recomputeCart();
        return { status: 'success' };
    }
    setTransportationCost(transporationcost) {
        this.cart.transportationcost = transporationcost;
        this.cart.editedtransportation = true;
        this.recomputeCart();
    }
    compputeGSTOnTransportation(cart) {
        if (cart.transportationcost > 0 && cart.maxgstpercent > 0) {
            var taxableamount = cart.transportationcost;
            var gstpercentage = cart.maxgstpercent;
            var gst = this.util.round((taxableamount) * gstpercentage / (100 + gstpercentage), 2);
            cart.transportationgst = gst;
        }
        else {
            cart.transportationgst = 0;
        }
    }
    computeTaxesOnLineitem(item) {
        var product = this.dataService.getProductForId(item.productid);
        var gstpercentage = product.gstpercentage;
        if (item.billingtype == 'RENT')
            gstpercentage = product.gstpercentagerent;
        if (product && gstpercentage && gstpercentage > 0) {
            var taxableamount = item.itemtaxableamount;
            //var gst =  this.util.round(gstpercentage / 100.0 * taxableamount,3);
            var gst = (taxableamount) * gstpercentage / (100 + gstpercentage);
            var cgst = this.util.round(gst / 2.0, 3);
            var sgst = this.util.round(gst / 2.0, 3);
            item.itemcgst = cgst;
            item.itemsgst = sgst;
            item.itemigst = 0;
            item.itemtaxes = gst;
        }
    }
    recomputeCart() {
        this.setCartTotalstoZero();
        if (!this.cart.editedtransportation)
            this.cart.transportationcost = 0;
        var maxgstpercent = 0;
        if (!this.cart.outskirtscost)
            this.cart.outskirtscost = 0;
        for (var item of this.cart.lineitems) {
            this.cart.sumitemcount = this.cart.sumitemcount + item.quantity;
            this.cart.sumitemamount = this.util.round(this.cart.sumitemamount + item.itemamount, 3);
            this.cart.sumitemcgst = this.util.round(this.cart.sumitemcgst + item.itemcgst, 3);
            this.cart.sumitemsgst = this.util.round(this.cart.sumitemsgst + item.itemsgst, 3);
            this.cart.sumitemigst = this.util.round(this.cart.sumitemigst + item.itemigst, 3);
            if (item.depositamount == null)
                item.depositamount = 0;
            this.cart.sumdepositamount = this.util.round(this.cart.sumdepositamount + item.depositamount, 3);
            this.cart.sumitemtaxes = this.util.round(this.cart.sumitemtaxes + item.itemtaxes, 3);
            this.cart.sumitemtaxableamount = this.util.round(this.cart.sumitemtaxableamount + item.itemtaxableamount, 3);
            this.cart.sumitemgross = this.util.round(this.cart.sumitemgross + item.itemgross, 3);
            this.cart.sumitempayable = this.util.round(this.cart.sumitempayable + item.totalpayableamount, 3);
            if (this.cart.handovermode != 'pickup' && !this.cart.editedtransportation) {
                if (item.transportationcost && item.transportationcost > this.cart.transportationcost) {
                    this.cart.transportationcost = item.transportationcost;
                }
                if (this.cart.outskirtsdelivery) {
                    if (item.outskirtstransportationcost && item.outskirtstransportationcost > 0 && item.outskirtstransportationcost > this.cart.transportationcost) {
                        this.cart.transportationcost = item.outskirtstransportationcost;
                    }
                }
            }
            if (item.gstpercent > maxgstpercent) {
                maxgstpercent = item.gstpercent;
            }
        }
        this.cart.maxgstpercent = maxgstpercent;
        this.compputeGSTOnTransportation(this.cart);
        this.cart.netpayable = Math.round(this.cart.sumitempayable + this.cart.transportationcost);
        this.cart.lineitems = [...this.cart.lineitems];
        localStorage.setItem("cart", JSON.stringify(this.cart));
    }
    sendOrderEmail(order) {
        return __awaiter(this, void 0, void 0, function* () {
            var url = "https://lj7724mli5.execute-api.ap-south-1.amazonaws.com/prod/sendorderemail";
            var body = { order: order };
            var headers = { 'content-type': 'application/json' };
            var resp = yield this.dynamoLib.httpdataService.httpRequest(url, 'POST', body, headers);
        });
    }
    postordertoQ5Care(order) {
        return __awaiter(this, void 0, void 0, function* () {
            var url = "https://lj7724mli5.execute-api.ap-south-1.amazonaws.com/prod/q5careorderpost";
            var body = JSON.stringify(order);
            var headers = { 'content-type': 'application/json' };
            var resp = yield this.dynamoLib.httpdataService.httpRequest(url, 'POST', body, headers);
            console.log('RESPONSE FROM Q5 CARE:: ' + JSON.stringify(resp));
            if (resp.status == 0) {
                return true;
            }
            return false;
        });
    }
    updateOrder(originalOrder, updatedorder) {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "updateOrder++");
            var cloneOrder = cloneDeep(updatedorder);
            if (originalOrder.curstatus != updatedorder.curstatus) {
                //if()
                //var laststatus  = cloneOrder.statustrack[cloneOrder.statustrack.length - 1];
                var sts = {};
                sts.statusreached = cloneOrder.curstatus;
                sts.reachedat = this.dynamoLib.getTime();
                //sts.timetaken = (this.dynamoLib.getTime() - laststatus.reachedat) / (1000*60);
                if (!cloneOrder.statustrack)
                    cloneOrder.statustrack = [];
                cloneOrder.statustrack.push(sts);
            }
            var txnitems = [];
            if (cloneOrder.cart && cloneOrder.cart.netpayable)
                cloneOrder.orderamount = cloneOrder.cart.netpayable;
            var txnitem = this.util.getTransactionItem('edit', this.util.getTableName('order'), cloneOrder);
            txnitems.push(txnitem);
            var auditItem = this.auditService.getOrderAuditTrail(originalOrder, updatedorder);
            if (auditItem) {
                var txnaudititem = this.util.getAuditTransactionItem(this.util.getTableName('setupaudittrail'), auditItem);
                txnitems.push(txnaudititem);
            }
            var retposting = true;
            if (cloneOrder.curstatus == 'Converted') {
                retposting = yield this.postordertoQ5Care(cloneOrder);
            }
            if (retposting) {
                var ret = yield this.dynamoLib.performTransaction(txnitems);
                if (!ret) {
                    return null;
                }
                this.updateOrderInMonitoring(updatedorder);
                //this.sendOrderEmail(order);
                this.util.log(Constants.LOG_DEBUG, "create ORder--");
                return updatedorder;
            }
            else {
                console.log('Error in posting');
            }
        });
    }
    setCity(cityname, outskirtsdelivery) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.cart && this.cart.sumitemcount > 0) {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'There are items in the cart, cant set the customer!' };
            }
            var cityfound = false;
            for (var city of this.dataService.citylist) {
                if (city.name == cityname) {
                    this.cityid = city.id;
                    cityfound = true;
                    break;
                }
            }
            if (!cityfound) {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid city!' };
            }
            this.cart.outskirtsdelivery = outskirtsdelivery;
            return { status: 'success' };
        });
    }
    setBusinessCustomer(b2bcustomer, cityname) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.cart && this.cart.sumitemcount > 0) {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'There are items in the cart, cant set the customer!' };
            }
            var cityfound = false;
            for (var city of this.dataService.citylist) {
                if (city.name == cityname) {
                    this.cityid = city.id;
                    cityfound = true;
                    break;
                }
            }
            if (!cityfound) {
                return { status: 'error', statuserrorcode: Constants.DML_MANDATORY_MISSING, errordescription: 'Invalid city!' };
            }
            this.b2bcustomer = b2bcustomer;
            return { status: 'success' };
        });
    }
    placeCCOrder(customertype, customer, b2bcustomer, address, billingaddress, leadsource, patientname, patientage, patientgender, paidamount, curstatus, orderdate, paymentmode, paymentreference, paymentremarks, agentid, agentname, leadremarks, cancelreason, cancelremarks, followupdate, billingcityid, billingcityname) {
        return __awaiter(this, void 0, void 0, function* () {
            var order = {};
            order.shippingaddress = address;
            if (billingaddress)
                order.billingaddress = billingaddress;
            else
                order.billingaddress = address;
            order.curstatus = curstatus;
            order.followupdate = followupdate;
            order.billingcityid = billingcityid;
            order.billingcityname = billingcityname;
            order.customertype = customertype;
            if (customertype == 'retail') {
                order.customerid = customer.id;
                order.customermobile = customer.mobileno;
                order.customername = customer.name;
                order.customer = customer;
            }
            else {
                order.customerid = b2bcustomer.id;
                order.customermobile = b2bcustomer.whatasappnummber;
                order.b2bcustomer = b2bcustomer;
                order.customername = b2bcustomer.orgname;
            }
            order.patientage = patientage;
            order.patientname = patientname;
            order.patientgender = patientgender;
            order.agentid = agentid;
            order.agentname = agentname;
            order.leadremarks = leadremarks;
            order.cancelreason = cancelreason;
            order.cancelremarks = cancelremarks;
            //order.closedby = closedby;
            order.leadsource = leadsource;
            order.orderdate = orderdate;
            order.cart = this.cart;
            order.orderamount = order.cart.netpayable;
            order.paidamount = paidamount;
            order.paymentlist = [];
            var payment = {};
            payment.paidamount = paidamount;
            payment.paymentmode = paymentmode;
            payment.paymentreference = paymentreference;
            payment.paymentremarks = paymentremarks;
            order.paymentlist.push(payment);
            order.id = "" + this.dynamoLib.getTime();
            var txnitems = [];
            order.statustrack = [];
            var sts = {};
            sts.statusreached = order.curstatus;
            sts.reachedat = this.dynamoLib.getTime();
            sts.timetaken = 0;
            order.statustrack.push(sts);
            var txnitem = this.util.getTransactionItem('create', this.util.getTableName('order'), order, "attribute_not_exists(id)");
            txnitems.push(txnitem);
            if (customertype == 'retail') {
                var cloneCustomer = cloneDeep(customer);
                if (!cloneCustomer.orderhistory)
                    cloneCustomer.orderhistory = [];
                cloneCustomer.orderhistory.push(order.id);
                var txnitemcust = this.util.getTransactionItem('edit', this.util.getTableName('customer'), cloneCustomer);
                txnitems.push(txnitemcust);
            }
            else {
                var cloneb2bCustomer = cloneDeep(b2bcustomer);
                if (!cloneb2bCustomer.orderhistory)
                    cloneb2bCustomer.orderhistory = [];
                cloneb2bCustomer.orderhistory.push(order.id);
                var txnitemcust = this.util.getTransactionItem('edit', this.util.getTableName('businesscustomer'), cloneb2bCustomer);
                txnitems.push(txnitemcust);
            }
            var retposting = true;
            if (order.curstatus == 'Converted') {
                retposting = yield this.postordertoQ5Care(order);
            }
            if (retposting) {
                var ret = yield this.dynamoLib.performTransaction(txnitems);
                if (!ret) {
                    return null;
                }
                this.allordersformonitoring.push(order);
                this.parseOrderlistFormonitoring();
                //this.sendOrderEmail(order);
                this.util.log(Constants.LOG_DEBUG, "create ORder--");
                return order;
            }
            else {
                console.log('Error in posting.. ');
                return null;
            }
        });
    }
    placeOrder(customer, address, paidamount, paymentmode, paymentreference, paymentremarks) {
        return __awaiter(this, void 0, void 0, function* () {
            var order = {};
            order.customer = customer;
            order.billingaddress = address;
            order.shippingaddress = address;
            order.customerid = customer.id;
            order.customermobile = customer.mobileno;
            order.cart = this.cart;
            order.orderamount = order.cart.netpayable;
            order.paidamount = paidamount;
            order.paymentlist = [];
            order.customertype = 'retail';
            order.leadsource = 'Web Order';
            order.createdby = 'weblead';
            order.curstatus = 'Hot';
            var payment = {};
            payment.paidamount = paidamount;
            payment.paymentmode = paymentmode;
            payment.paymentreference = paymentreference;
            payment.paymentremarks = paymentremarks;
            order.paymentlist.push(payment);
            order.id = "" + this.dynamoLib.getTime();
            var txnitems = [];
            var txnitem = this.util.getTransactionItem('create', this.util.getTableName('order'), order, "attribute_not_exists(id)");
            txnitems.push(txnitem);
            var cloneCustomer = cloneDeep(customer);
            if (!cloneCustomer.orderhistory)
                cloneCustomer.orderhistory = [];
            cloneCustomer.orderhistory.push(order.id);
            var txnitemcust = this.util.getTransactionItem('edit', this.util.getTableName('customer'), cloneCustomer);
            txnitems.push(txnitemcust);
            /*var retposting  = await this.postordertoQ5Care(order);
            if(!retposting){
              order.postingfailed = true;
            }*/
            var ret = yield this.dynamoLib.performTransaction(txnitems);
            if (!ret) {
                return null;
            }
            this.sendOrderEmail(order);
            this.util.log(Constants.LOG_DEBUG, "create ORder--");
            return order;
        });
    }
    setHandovermode(handovermode) {
        return __awaiter(this, void 0, void 0, function* () {
            this.cart.handovermode = handovermode;
            this.recomputeCart();
        });
    }
    setListsToEmpty() {
        this.newordersformonitoring = [];
        this.inprocessordersformonitoring = [];
        this.hotordersformonitoring = [];
    }
    sortOrderbyTimeDesc(orderlist) {
        orderlist.sort((a, b) => (a.createdat) > (b.createdat) ? -1 : 1);
    }
    updateOrderInMonitoring(order) {
        for (var i = 0; i < this.allordersformonitoring.length; i++) {
            var curorder = this.allordersformonitoring[i];
            if (curorder.id == order.id) {
                if (order.curstatus == 'New' || order.curstatus == 'In Process' || order.curstatus == 'Hot') {
                    this.allordersformonitoring[i] = order;
                }
                else {
                    this.allordersformonitoring.splice(i, 1);
                }
                this.allordersformonitoring = [...this.allordersformonitoring];
                this.parseOrderlistFormonitoring();
                return;
            }
        }
    }
    parseOrderlistFormonitoring() {
        //this.setListsToEmpty();
        for (var order of this.allordersformonitoring) {
            console.log('|MON|ORDERID ' + order.id + ' ORDER STATUS ' + order.curstatus);
            if (order.curstatus == 'New')
                this.newordersformonitoring.push(order);
            if (order.curstatus == 'In Process')
                this.inprocessordersformonitoring.push(order);
            if (order.curstatus == 'Hot')
                this.hotordersformonitoring.push(order);
        }
        console.log('|MON|NEW LENGTH ' + this.newordersformonitoring.length);
        this.sortOrderbyTimeDesc(this.newordersformonitoring);
        this.sortOrderbyTimeDesc(this.inprocessordersformonitoring);
        this.sortOrderbyTimeDesc(this.hotordersformonitoring);
        this.newordersformonitoring = [...this.newordersformonitoring];
        this.inprocessordersformonitoring = [...this.inprocessordersformonitoring];
        this.hotordersformonitoring = [...this.hotordersformonitoring];
    }
    setOrdermonitoringList() {
        return __awaiter(this, void 0, void 0, function* () {
            this.setListsToEmpty();
            this.allordersformonitoring = [];
            var curtime = this.dynamoLib.getTime();
            var curonlydate = new Date(formatDate(curtime, "yyyy-MM-dd", "en")).getTime();
            var strtodate = formatDate(curtime, "yyyy-MM-dd", "en") + " 23:59";
            var starttime = curonlydate - (24 * 30 * 60 * 60 * 1000);
            var strfromdate = formatDate(starttime, "yyyy-MM-dd", "en") + " 00:00";
            var orderlist = yield this.getOrderList("retail", strfromdate, strtodate);
            var orderlistcorporate = yield this.getOrderList("corporate", strfromdate, strtodate);
            orderlist = orderlist.concat(orderlistcorporate);
            var usergroupname = this.dataService.loggedinuser.usergroupname;
            if (orderlist) {
                for (var ord of orderlist) {
                    if (usergroupname.includes('admin') || ord.createdby == this.util.loggedinusername) {
                        if (ord.curstatus == 'New' || ord.curstatus == 'In Process' || ord.curstatus == 'Hot')
                            this.allordersformonitoring.push(ord);
                    }
                }
                this.parseOrderlistFormonitoring();
            }
        });
    }
    getOrderList(customertype, fromdate, todate) {
        return __awaiter(this, void 0, void 0, function* () {
            var tablename = this.util.getTableName('order');
            var strfromdate = fromdate + " 00:00";
            var strtodate = todate + " 23:59";
            if (strfromdate < "2022-12-02")
                strfromdate = "2022-12-02 00:00";
            var conditionexpression = "customertype = :v_custtype and createdat BETWEEN :v_start and :v_end ";
            var attribparams = { ":v_custtype": customertype, ":v_start": strfromdate, ":v_end": strtodate };
            var retlist = [];
            var allorderlist = yield this.dynamoLib.queryDB(tablename, "customertype-createdat-index", conditionexpression, null, null, attribparams, null, null, null, true, true);
            for (var ord of allorderlist) {
                ord.orderamount = 0;
                ord.taxableamount = 0;
                if (ord.cart) {
                    ord.orderamount = ord.cart.netpayable;
                    ord.taxableamount = this.util.round(ord.cart.sumitemtaxableamount, 2);
                }
                if (this.dataService.loggedinuser.usergroupname.includes('admin') || ord.createdby == this.util.loggedinusername) {
                    retlist.push(ord);
                }
                if (ord.customertype == 'retail') {
                    if (ord.customer) {
                        ord.customermobile = ord.customer.mobileno;
                        ord.customername = ord.customer.name;
                    }
                }
                else {
                    if (ord.b2bcustomer) {
                        ord.customermobile = ord.b2bcustomer.whatasappnummber;
                        ord.customername = ord.b2bcustomer.orgname;
                    }
                }
                if (!ord.billingcityid) {
                    if (ord.shippingaddress.cityid) {
                        var cityidx = this.dataService.getIndexInMasterList(this.dataService.citylist, ord.shippingaddress.cityid);
                        if (cityidx > -1) {
                            var ordcity = this.dataService.citylist[cityidx];
                            if (ordcity.billingcityid)
                                ord.billingcityid = ordcity.billingcityid;
                            else
                                ord.billingcityid = ordcity.id;
                        }
                    }
                }
                if (ord.billingcityid) {
                    var blncityidx = this.dataService.getIndexInMasterList(this.dataService.citylist, ord.billingcityid);
                    if (blncityidx > -1) {
                        var ordblncity = this.dataService.citylist[blncityidx];
                        ord.billingcityname = ordblncity.name;
                    }
                }
                ord.paymentmode = "";
                if (ord.paymentlist && ord.paymentlist.length > 0) {
                    for (var pymt of ord.paymentlist) {
                        ord.paymentmode = ord.paymentmode + pymt.paymentmode + ", ";
                    }
                    ord.paymentmode = ord.paymentmode.substring(0, ord.paymentmode.length - 2);
                }
                if (ord.curstatus == 'Cancel')
                    ord.curstatus = 'Lead Cancelled';
                if (ord.curstatus == 'Cancelled')
                    ord.curstatus = 'Order Cancelled';
            }
            return retlist;
        });
    }
    getNewCalls() {
        return __awaiter(this, void 0, void 0, function* () {
            var tablename = this.util.getTableName('callalert');
            var conditionexpression = "callstatus = :v_callstatus ";
            var attribparams = { ":v_callstatus": 'New' };
            return yield this.dynamoLib.queryDB(tablename, "callstatus-index", conditionexpression, null, null, attribparams, null, null, null, true, true);
        });
    }
    updateCall(updatedCall) {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "updateCall++");
            var cloneCall = cloneDeep(updatedCall);
            var txnitems = [];
            var txnitem = this.util.getTransactionItem('edit', this.util.getTableName('callalert'), cloneCall);
            txnitems.push(txnitem);
            var ret = yield this.dynamoLib.performTransaction(txnitems);
            if (!ret) {
                return null;
            }
            return cloneCall;
        });
    }
    getCustomerOrderHistory(customermobile) {
        return __awaiter(this, void 0, void 0, function* () {
            this.util.log(Constants.LOG_DEBUG, "getcustomerorderhistory++");
            var tablename = this.util.getTableName('order');
            var conditionexpression = "customermobile = :v_customermobile ";
            var attribparams = { ":v_customermobile": customermobile };
            return yield this.dynamoLib.queryDB(tablename, "customermobile-index", conditionexpression, null, null, attribparams, null, null, null, true, true);
            this.util.log(Constants.LOG_DEBUG, "getcustomerorderhistory--");
        });
    }
}
OrderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: OrderService, deps: [{ token: ValidatorService }, { token: ArchivecheckService }, { token: AuditService }, { token: AppdataService }, { token: UtilService }, { token: i3.DynamoLibService }], target: i0.ɵɵFactoryTarget.Injectable });
OrderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: OrderService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: OrderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ValidatorService }, { type: ArchivecheckService }, { type: AuditService }, { type: AppdataService }, { type: UtilService }, { type: i3.DynamoLibService }]; } });

class Quali5carelibService {
    constructor(util, excelService, privService, vendorService, dbLib, auditService, setupService, dataService, loginService, orderService) {
        this.util = util;
        this.excelService = excelService;
        this.privService = privService;
        this.vendorService = vendorService;
        this.dbLib = dbLib;
        this.auditService = auditService;
        this.setupService = setupService;
        this.dataService = dataService;
        this.loginService = loginService;
        this.orderService = orderService;
    }
}
Quali5carelibService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: Quali5carelibService, deps: [{ token: UtilService }, { token: ExcelimportService }, { token: PrivilegeService }, { token: VendorService }, { token: i3.DynamoLibService }, { token: AuditService }, { token: SetupService }, { token: AppdataService }, { token: LoginService }, { token: OrderService }], target: i0.ɵɵFactoryTarget.Injectable });
Quali5carelibService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: Quali5carelibService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: Quali5carelibService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: UtilService }, { type: ExcelimportService }, { type: PrivilegeService }, { type: VendorService }, { type: i3.DynamoLibService }, { type: AuditService }, { type: SetupService }, { type: AppdataService }, { type: LoginService }, { type: OrderService }]; } });

class Quali5carelibComponent {
    constructor() { }
    ngOnInit() {
    }
}
Quali5carelibComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: Quali5carelibComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
Quali5carelibComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: Quali5carelibComponent, selector: "lib-quali5carelib", ngImport: i0, template: `
    <p>
      quali5carelib works!
    </p>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: Quali5carelibComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-quali5carelib',
                    template: `
    <p>
      quali5carelib works!
    </p>
  `,
                    styles: []
                }]
        }], ctorParameters: function () { return []; } });

class Quali5carelibModule {
}
Quali5carelibModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: Quali5carelibModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
Quali5carelibModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: Quali5carelibModule, declarations: [Quali5carelibComponent], exports: [Quali5carelibComponent] });
Quali5carelibModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: Quali5carelibModule, imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: Quali5carelibModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        Quali5carelibComponent
                    ],
                    imports: [],
                    exports: [
                        Quali5carelibComponent
                    ]
                }]
        }] });

/*
 * Public API Surface of quali5carelib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Quali5carelibComponent, Quali5carelibModule, Quali5carelibService };
